// PLANTS BONUS - Part 1
// Clean database with regional names support

import { PlantData } from './plants-master-database'

export const bonusData: PlantData[] = [
  {
    id: 'edible-flowers-mix',
    name: 'Edible Flowers Mix',
    scientificName: 'Various',
    category: 'flower',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['herbs'],
    enemies: [],
    description: 'Mix of nasturtium, calendula, borage, and violas for garnishing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '6-12 inches',
    family: 'Various',
    varieties: ['Nasturtium', 'Calendula', 'Borage'],
    uses: ['garnish', 'salads', 'decoration']
  },
  {
    id: 'microgreens-mix',
    name: 'Microgreens Mix',
    scientificName: 'Various',
    category: 'vegetable',
    spacing: 1,
    rowSpacing: 1,
    daysToGermination: 5,
    daysToHarvest: 14,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Quick growing baby greens. Harvest at 1-3 inches for intense flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'any',
    height: '1-3 inches',
    spread: 'dense',
    family: 'Various',
    varieties: ['Spicy', 'Mild', 'Rainbow'],
    uses: ['salads', 'garnish', 'sandwiches']
  },
  {
    id: 'sprouts-mix',
    name: 'Sprouts Mix',
    scientificName: 'Various',
    category: 'vegetable',
    spacing: 0,
    rowSpacing: 0,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'shade',
    water: 'high',
    soil: 'none',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Grow in jars without soil. Mung bean, alfalfa, broccoli sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'any',
    height: '2-4 inches',
    spread: 'jar',
    family: 'Various',
    varieties: ['Mung', 'Alfalfa', 'Broccoli'],
    uses: ['salads', 'sandwiches', 'stir fry']
  },
  {
    id: 'wheatgrass',
    name: 'Wheatgrass',
    scientificName: 'Triticum aestivum',
    category: 'grain',
    spacing: 1,
    rowSpacing: 1,
    daysToGermination: 7,
    daysToHarvest: 14,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Young wheat shoots for juicing. High in chlorophyll and nutrients.',
    hardinessZones: 'indoor',
    plantingSeason: 'any',
    height: '6-8 inches',
    spread: 'tray',
    family: 'Poaceae',
    varieties: ['Hard Red Winter'],
    uses: ['juicing', 'smoothies', 'health']
  }
,
  {
    id: 'sunflower-mammoth-grey-stripe',
    name: 'Sunflower - Mammoth Grey Stripe',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Mammoth Grey Stripe'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-russian-giant',
    name: 'Sunflower - Russian Giant',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Russian Giant'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-titan',
    name: 'Sunflower - Titan',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Titan'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-skyscraper',
    name: 'Sunflower - Skyscraper',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Skyscraper'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-american-giant-hybrid',
    name: 'Sunflower - American Giant Hybrid',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['American Giant Hybrid'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-giant-sungold',
    name: 'Sunflower - Giant Sungold',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Giant Sungold'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'zinnia-lemon-queen',
    name: 'Zinnia - Lemon Queen',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'lemon tall zinnia. Classic garden zinnia. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '30-40 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Lemon Queen'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'sunflower-italian-white',
    name: 'Sunflower - Italian White',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'white tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Italian White'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-moulin-rouge',
    name: 'Sunflower - Moulin Rouge',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'red tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Moulin Rouge'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-claret',
    name: 'Sunflower - Claret',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'burgundy tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Claret'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'zinnia-velvet-queen',
    name: 'Zinnia - Velvet Queen',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'burgundy tall zinnia. Classic garden zinnia. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '30-40 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Velvet Queen'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'sunflower-chianti',
    name: 'Sunflower - Chianti',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'red tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Chianti'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-red-sun',
    name: 'Sunflower - Red Sun',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'red tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Red Sun'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-autumn-beauty',
    name: 'Sunflower - Autumn Beauty',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed tall sunflower. Classic garden sunflower. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Autumn Beauty'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-evening-sun',
    name: 'Sunflower - Evening Sun',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed tall sunflower. Classic garden sunflower. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Evening Sun'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-indian-blanket',
    name: 'Sunflower - Indian Blanket',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed tall sunflower. Classic garden sunflower. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Indian Blanket'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-strawberry-blonde',
    name: 'Sunflower - Strawberry Blonde',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'pink tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Strawberry Blonde'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-peach-passion',
    name: 'Sunflower - Peach Passion',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'peach tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Peach Passion'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-procut-orange',
    name: 'Sunflower - ProCut Orange',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange cut sunflower. Pollenless, perfect for florists. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-6 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['ProCut Orange'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-procut-yellow',
    name: 'Sunflower - ProCut Yellow',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow cut sunflower. Pollenless, perfect for florists. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-6 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['ProCut Yellow'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-procut-red',
    name: 'Sunflower - ProCut Red',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'red cut sunflower. Pollenless, perfect for florists. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-6 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['ProCut Red'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-procut-white-nite',
    name: 'Sunflower - ProCut White Nite',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'white cut sunflower. Pollenless, perfect for florists. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-6 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['ProCut White Nite'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-procut-plum',
    name: 'Sunflower - ProCut Plum',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'plum cut sunflower. Pollenless, perfect for florists. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-6 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['ProCut Plum'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-procut-bicolor',
    name: 'Sunflower - ProCut Bicolor',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'bi cut sunflower. Pollenless, perfect for florists. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-6 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['ProCut Bicolor'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-sunrich-orange',
    name: 'Sunflower - Sunrich Orange',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange cut sunflower. Pollenless, perfect for florists. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-6 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Sunrich Orange'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-sunrich-lemon',
    name: 'Sunflower - Sunrich Lemon',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'lemon cut sunflower. Pollenless, perfect for florists. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-6 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Sunrich Lemon'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-sunrich-gold',
    name: 'Sunflower - Sunrich Gold',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold cut sunflower. Pollenless, perfect for florists. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-6 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Sunrich Gold'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-sunrich-orange-summer',
    name: 'Sunflower - Sunrich Orange Summer',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange cut sunflower. Pollenless, perfect for florists. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-6 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Sunrich Orange Summer'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-teddy-bear',
    name: 'Sunflower - Teddy Bear',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Teddy Bear'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-suntastic-yellow',
    name: 'Sunflower - Suntastic Yellow',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Suntastic Yellow'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-suntastic-orange',
    name: 'Sunflower - Suntastic Orange',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Suntastic Orange'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-suntastic-bicolor',
    name: 'Sunflower - Suntastic Bicolor',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'bi dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Suntastic Bicolor'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-junior',
    name: 'Sunflower - Junior',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Junior'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-big-smile',
    name: 'Sunflower - Big Smile',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Big Smile'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-sunspot',
    name: 'Sunflower - Sunspot',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Sunspot'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-elf',
    name: 'Sunflower - Elf',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Elf'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-topolino',
    name: 'Sunflower - Topolino',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Topolino'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-sunny-smile',
    name: 'Sunflower - Sunny Smile',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Sunny Smile'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-music-box',
    name: 'Sunflower - Music Box',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed dwarf sunflower. Compact 2-4 feet, perfect for containers. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Music Box'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-double-dandy',
    name: 'Sunflower - Double Dandy',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'red dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Double Dandy'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-double-quick-orange',
    name: 'Sunflower - Double Quick Orange',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Double Quick Orange'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-double-shine',
    name: 'Sunflower - Double Shine',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Double Shine'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-chocolate-cherry',
    name: 'Sunflower - Chocolate Cherry',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'chocolate branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Chocolate Cherry'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-fire-catcher',
    name: 'Sunflower - Fire Catcher',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Fire Catcher'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-gummy-bear',
    name: 'Sunflower - Gummy Bear',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Gummy Bear'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-lemon-rush',
    name: 'Sunflower - Lemon Rush',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'lemon branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Lemon Rush'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-ms-mars',
    name: 'Sunflower - Ms Mars',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'purple branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Ms Mars'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-royal-flush',
    name: 'Sunflower - Royal Flush',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'purple branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Royal Flush'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-shock-o-lat',
    name: 'Sunflower - Shock-o-Lat',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'chocolate branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Shock-o-Lat'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-starburst-panache',
    name: 'Sunflower - Starburst Panache',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'bi branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Starburst Panache'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-sun-fill-purple',
    name: 'Sunflower - Sun Fill Purple',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'purple branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Sun Fill Purple'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-sun-fill-green',
    name: 'Sunflower - Sun Fill Green',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'green branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Sun Fill Green'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-sonja',
    name: 'Sunflower - Sonja',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Sonja'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-zohar',
    name: 'Sunflower - Zohar',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Zohar'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-benarys-giant-golden-yellow',
    name: 'Sunflower - Benarys Giant Golden Yellow',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Benarys Giant Golden Yellow'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-benarys-giant-lemon',
    name: 'Sunflower - Benarys Giant Lemon',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'lemon branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Benarys Giant Lemon'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-benarys-giant-orange',
    name: 'Sunflower - Benarys Giant Orange',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Benarys Giant Orange'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-benarys-giant-deep-orange',
    name: 'Sunflower - Benarys Giant Deep Orange',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'deep orange branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Benarys Giant Deep Orange'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-benarys-giant-light-gold',
    name: 'Sunflower - Benarys Giant Light Gold',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'light gold branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Benarys Giant Light Gold'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-inca-gold',
    name: 'Sunflower - Inca Gold',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Inca Gold'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-jua-maya',
    name: 'Sunflower - Jua Maya',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Jua Maya'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-premier-light-yellow',
    name: 'Sunflower - Premier Light Yellow',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'light yellow branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Premier Light Yellow'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-premier-orange',
    name: 'Sunflower - Premier Orange',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Premier Orange'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-premier-lemon',
    name: 'Sunflower - Premier Lemon',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'lemon branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Premier Lemon'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-full-sun',
    name: 'Sunflower - Full Sun',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Full Sun'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-giganteus',
    name: 'Sunflower - Giganteus',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Giganteus'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-kong-hybrid',
    name: 'Sunflower - Kong Hybrid',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed branching sunflower. Multiple blooms per stem, great for cutting. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Kong Hybrid'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-solar-power',
    name: 'Sunflower - Solar Power',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Solar Power'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-sunzilla',
    name: 'Sunflower - Sunzilla',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Sunzilla'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-sunforest-mix',
    name: 'Sunflower - Sunforest Mix',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Sunforest Mix'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-garden-statement',
    name: 'Sunflower - Garden Statement',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Garden Statement'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-golden-cheer',
    name: 'Sunflower - Golden Cheer',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Golden Cheer'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-helios-flame',
    name: 'Sunflower - Helios Flame',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'bi tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Helios Flame'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-irish-eyes',
    name: 'Sunflower - Irish Eyes',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'green center tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Irish Eyes'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-joker',
    name: 'Sunflower - Joker',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed tall sunflower. Classic garden sunflower. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Joker'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-loddon-gold',
    name: 'Sunflower - Loddon Gold',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Loddon Gold'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-paul-bunyan',
    name: 'Sunflower - Paul Bunyan',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Paul Bunyan'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-peredovik',
    name: 'Sunflower - Peredovik',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'black oil sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Peredovik'],
    uses: ['seeds', 'oil', 'bird feed']
  },
  {
    id: 'sunflower-royal-hybrid',
    name: 'Sunflower - Royal Hybrid',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow oil sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Royal Hybrid'],
    uses: ['seeds', 'oil', 'bird feed']
  },
  {
    id: 'sunflower-snack-seed',
    name: 'Sunflower - Snack Seed',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'striped confection sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Snack Seed'],
    uses: ['seeds', 'oil', 'bird feed']
  },
  {
    id: 'sunflower-super-snack-mix',
    name: 'Sunflower - Super Snack Mix',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed confection sunflower. Classic garden sunflower. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Super Snack Mix'],
    uses: ['seeds', 'oil', 'bird feed']
  },
  {
    id: 'sunflower-tarheel',
    name: 'Sunflower - Tarheel',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gray confection sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Tarheel'],
    uses: ['seeds', 'oil', 'bird feed']
  },
  {
    id: 'sunflower-tiger-eye',
    name: 'Sunflower - Tiger Eye',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold confection sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Tiger Eye'],
    uses: ['seeds', 'oil', 'bird feed']
  },
  {
    id: 'sunflower-willowleaf',
    name: 'Sunflower - Willowleaf',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Willowleaf'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-zebulon-ross',
    name: 'Sunflower - Zebulon Ross',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'striped confection sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Zebulon Ross'],
    uses: ['seeds', 'oil', 'bird feed']
  },
  {
    id: 'sunflower-alpine-glow',
    name: 'Sunflower - Alpine Glow',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'red yellow tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Alpine Glow'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-apricot-twist',
    name: 'Sunflower - Apricot Twist',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'apricot tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Apricot Twist'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-aztec-sun',
    name: 'Sunflower - Aztec Sun',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Aztec Sun'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-ballad',
    name: 'Sunflower - Ballad',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow cut sunflower. Pollenless, perfect for florists. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-6 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Ballad'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-beacon',
    name: 'Sunflower - Beacon',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Beacon'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-big-bear',
    name: 'Sunflower - Big Bear',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Big Bear'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-black-oil',
    name: 'Sunflower - Black Oil',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'black oil sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Black Oil'],
    uses: ['seeds', 'oil', 'bird feed']
  },
  {
    id: 'sunflower-bling',
    name: 'Sunflower - Bling',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Bling'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-bloody-mary',
    name: 'Sunflower - Bloody Mary',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'red tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Bloody Mary'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-buttercream',
    name: 'Sunflower - Buttercream',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'cream tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Buttercream'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-cappuccino',
    name: 'Sunflower - Cappuccino',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'coffee tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Cappuccino'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-carmel',
    name: 'Sunflower - Carmel',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'caramel tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Carmel'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-cherry-rose',
    name: 'Sunflower - Cherry Rose',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'cherry tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Cherry Rose'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-coconut-ice',
    name: 'Sunflower - Coconut Ice',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'white tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Coconut Ice'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'zinnia-copper-queen',
    name: 'Zinnia - Copper Queen',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'copper tall zinnia. Classic garden zinnia. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '30-40 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Copper Queen'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'sunflower-crimson-glory',
    name: 'Sunflower - Crimson Glory',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'crimson tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Crimson Glory'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-dakota',
    name: 'Sunflower - Dakota',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Dakota'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-dorado',
    name: 'Sunflower - Dorado',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Dorado'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-double-quick',
    name: 'Sunflower - Double Quick',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed dwarf sunflower. Compact 2-4 feet, perfect for containers. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Double Quick'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-dwarf-sunspot',
    name: 'Sunflower - Dwarf Sunspot',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Dwarf Sunspot'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-earthwalker',
    name: 'Sunflower - Earthwalker',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed tall sunflower. Classic garden sunflower. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Earthwalker'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-elf',
    name: 'Sunflower - Elf',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Elf'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-floristan',
    name: 'Sunflower - Floristan',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'bi cut sunflower. Pollenless, perfect for florists. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-6 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Floristan'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-frilly',
    name: 'Sunflower - Frilly',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Frilly'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-funny-girl',
    name: 'Sunflower - Funny Girl',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'white tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Funny Girl'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-giant-primrose',
    name: 'Sunflower - Giant Primrose',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'primrose giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Giant Primrose'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-giganteus',
    name: 'Sunflower - Giganteus',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Giganteus'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-gold-rush',
    name: 'Sunflower - Gold Rush',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Gold Rush'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-golden-burst',
    name: 'Sunflower - Golden Burst',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Golden Burst'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-golden-gremlin',
    name: 'Sunflower - Golden Gremlin',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Golden Gremlin'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-golden-halo',
    name: 'Sunflower - Golden Halo',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Golden Halo'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-golden-jubilee',
    name: 'Sunflower - Golden Jubilee',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Golden Jubilee'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-greenburst',
    name: 'Sunflower - Greenburst',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'green tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Greenburst'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-harlequin-mixed',
    name: 'Sunflower - Harlequin Mixed',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed tall sunflower. Classic garden sunflower. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Harlequin Mixed'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-holiday',
    name: 'Sunflower - Holiday',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'red yellow tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Holiday'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-honey-bear',
    name: 'Sunflower - Honey Bear',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'honey tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Honey Bear'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-huggy-bear',
    name: 'Sunflower - Huggy Bear',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Huggy Bear'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-ikarus',
    name: 'Sunflower - Ikarus',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Ikarus'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-illusion',
    name: 'Sunflower - Illusion',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed tall sunflower. Classic garden sunflower. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Illusion'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-jade',
    name: 'Sunflower - Jade',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'green tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Jade'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-joker',
    name: 'Sunflower - Joker',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed tall sunflower. Classic garden sunflower. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Joker'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-kong',
    name: 'Sunflower - Kong',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Kong'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-large-flowered-mix',
    name: 'Sunflower - Large Flowered Mix',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed tall sunflower. Classic garden sunflower. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Large Flowered Mix'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-lemon-aura',
    name: 'Sunflower - Lemon Aura',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'lemon tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Lemon Aura'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-lemon-sorbet',
    name: 'Sunflower - Lemon Sorbet',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'lemon tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Lemon Sorbet'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-little-becka',
    name: 'Sunflower - Little Becka',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Little Becka'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-lemonade',
    name: 'Sunflower - Lemonade',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'lemon tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Lemonade'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-magic-roundabout',
    name: 'Sunflower - Magic Roundabout',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed tall sunflower. Classic garden sunflower. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Magic Roundabout'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-mars',
    name: 'Sunflower - Mars',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'red tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Mars'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-mars-attack',
    name: 'Sunflower - Mars Attack',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'red tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Mars Attack'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-merry-sunshine',
    name: 'Sunflower - Merry Sunshine',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Merry Sunshine'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-mongolian-giant',
    name: 'Sunflower - Mongolian Giant',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Mongolian Giant'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-moonshadow',
    name: 'Sunflower - Moonshadow',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'white tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Moonshadow'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-moonwalker',
    name: 'Sunflower - Moonwalker',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'pale tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Moonwalker'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-ms-mars',
    name: 'Sunflower - Ms Mars',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'purple branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Ms Mars'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-orange-ruffles',
    name: 'Sunflower - Orange Ruffles',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Orange Ruffles'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-orange-sun',
    name: 'Sunflower - Orange Sun',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Orange Sun'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-pastiche',
    name: 'Sunflower - Pastiche',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed tall sunflower. Classic garden sunflower. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Pastiche'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-peach-passion',
    name: 'Sunflower - Peach Passion',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'peach tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Peach Passion'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-perfection',
    name: 'Sunflower - Perfection',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Perfection'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-pike-peak',
    name: 'Sunflower - Pike Peak',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Pike Peak'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-pinocchio',
    name: 'Sunflower - Pinocchio',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed dwarf sunflower. Compact 2-4 feet, perfect for containers. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Pinocchio'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-plum',
    name: 'Sunflower - Plum',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'plum tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Plum'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-poker',
    name: 'Sunflower - Poker',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'red tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Poker'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-polar-bear',
    name: 'Sunflower - Polar Bear',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'white tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Polar Bear'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-prairie-sun',
    name: 'Sunflower - Prairie Sun',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Prairie Sun'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-procut',
    name: 'Sunflower - ProCut',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed cut sunflower. Pollenless, perfect for florists. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-6 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['ProCut'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-ring-of-fire',
    name: 'Sunflower - Ring of Fire',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'red yellow tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Ring of Fire'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-rostov',
    name: 'Sunflower - Rostov',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Rostov'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-royal',
    name: 'Sunflower - Royal',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Royal'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-ruby-eclipse',
    name: 'Sunflower - Ruby Eclipse',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'ruby tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Ruby Eclipse'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-saffron',
    name: 'Sunflower - Saffron',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Saffron'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-sante',
    name: 'Sunflower - Sante',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Sante'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-satsuma',
    name: 'Sunflower - Satsuma',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Satsuma'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-schweinitzii',
    name: 'Sunflower - Schweinitzii',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'purple tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Schweinitzii'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-shine',
    name: 'Sunflower - Shine',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Shine'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-shock-o-lat',
    name: 'Sunflower - Shock-o-Lat',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'chocolate branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Shock-o-Lat'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-solar-eclipse',
    name: 'Sunflower - Solar Eclipse',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'chocolate tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Solar Eclipse'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-solar-flash',
    name: 'Sunflower - Solar Flash',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Solar Flash'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-solar-gold',
    name: 'Sunflower - Solar Gold',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Solar Gold'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-solar-power',
    name: 'Sunflower - Solar Power',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Solar Power'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-soraya',
    name: 'Sunflower - Soraya',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Soraya'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-starburst-lemon-aura',
    name: 'Sunflower - Starburst Lemon Aura',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'lemon branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Starburst Lemon Aura'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-starburst-panache',
    name: 'Sunflower - Starburst Panache',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'bi branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Starburst Panache'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-strawberry-blonde',
    name: 'Sunflower - Strawberry Blonde',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'pink tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Strawberry Blonde'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-sugar-drop',
    name: 'Sunflower - Sugar Drop',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Sugar Drop'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-sundance-kid',
    name: 'Sunflower - Sundance Kid',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Sundance Kid'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-sunny',
    name: 'Sunflower - Sunny',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Sunny'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-sunny-smile',
    name: 'Sunflower - Sunny Smile',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Sunny Smile'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-sunray',
    name: 'Sunflower - Sunray',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Sunray'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-sunrise',
    name: 'Sunflower - Sunrise',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Sunrise'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-sunshine-daydream',
    name: 'Sunflower - Sunshine Daydream',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Sunshine Daydream'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-super-snack',
    name: 'Sunflower - Super Snack',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'striped confection sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Super Snack'],
    uses: ['seeds', 'oil', 'bird feed']
  },
  {
    id: 'sunflower-tarahumara',
    name: 'Sunflower - Tarahumara',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'white tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Tarahumara'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-tashkent',
    name: 'Sunflower - Tashkent',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Tashkent'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-titan',
    name: 'Sunflower - Titan',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Titan'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-topolino',
    name: 'Sunflower - Topolino',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Topolino'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-torch',
    name: 'Sunflower - Torch',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Torch'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-tremendous',
    name: 'Sunflower - Tremendous',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Tremendous'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-trophy',
    name: 'Sunflower - Trophy',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Trophy'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-ultra',
    name: 'Sunflower - Ultra',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Ultra'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-valentine',
    name: 'Sunflower - Valentine',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'lemon tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Valentine'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-vanilla-ice',
    name: 'Sunflower - Vanilla Ice',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'white tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Vanilla Ice'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'zinnia-velvet-queen',
    name: 'Zinnia - Velvet Queen',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'burgundy tall zinnia. Classic garden zinnia. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '30-40 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Velvet Queen'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'sunflower-waooh',
    name: 'Sunflower - Waooh',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed tall sunflower. Classic garden sunflower. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Waooh'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-white-lite',
    name: 'Sunflower - White Lite',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'white tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['White Lite'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-white-magic',
    name: 'Sunflower - White Magic',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'white tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['White Magic'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-white-nite',
    name: 'Sunflower - White Nite',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'white cut sunflower. Pollenless, perfect for florists. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-6 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['White Nite'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-white-shadow',
    name: 'Sunflower - White Shadow',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'white tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['White Shadow'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-willowleaf',
    name: 'Sunflower - Willowleaf',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Willowleaf'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-wow',
    name: 'Sunflower - WOW',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['WOW'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-xmas',
    name: 'Sunflower - Xmas',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'red white tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Xmas'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-yellow-disk',
    name: 'Sunflower - Yellow Disk',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Yellow Disk'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-yellow-empress',
    name: 'Sunflower - Yellow Empress',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow tall sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Yellow Empress'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-yellow-giant',
    name: 'Sunflower - Yellow Giant',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Yellow Giant'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-yellow-pygmy',
    name: 'Sunflower - Yellow Pygmy',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Yellow Pygmy'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-yellow-scoop',
    name: 'Sunflower - Yellow Scoop',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow dwarf sunflower. Compact 2-4 feet, perfect for containers. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Yellow Scoop'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-zebulon-ross',
    name: 'Sunflower - Zebulon Ross',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'striped confection sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Zebulon Ross'],
    uses: ['seeds', 'oil', 'bird feed']
  },
  {
    id: 'sunflower-zohar',
    name: 'Sunflower - Zohar',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange branching sunflower. Multiple blooms per stem, great for cutting. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Zohar'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-benarys-giant-mix',
    name: 'Sunflower - Benarys Giant Mix',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Benarys Giant Mix'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-benarys-giant-coral',
    name: 'Sunflower - Benarys Giant Coral',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'coral giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Benarys Giant Coral'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-benarys-giant-deep-red',
    name: 'Sunflower - Benarys Giant Deep Red',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'deep red giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Benarys Giant Deep Red'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-benarys-giant-lilac',
    name: 'Sunflower - Benarys Giant Lilac',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'lilac giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Benarys Giant Lilac'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-benarys-giant-wine',
    name: 'Sunflower - Benarys Giant Wine',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'wine giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Benarys Giant Wine'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-benarys-giant-golden-yellow',
    name: 'Sunflower - Benarys Giant Golden Yellow',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Benarys Giant Golden Yellow'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-benarys-giant-bright-pink',
    name: 'Sunflower - Benarys Giant Bright Pink',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'pink giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Benarys Giant Bright Pink'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-benarys-giant-scarlet',
    name: 'Sunflower - Benarys Giant Scarlet',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'scarlet giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Benarys Giant Scarlet'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-benarys-giant-white',
    name: 'Sunflower - Benarys Giant White',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'white giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Benarys Giant White'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-california-giant-mix',
    name: 'Sunflower - California Giant Mix',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed giant sunflower. Huge heads to 12+ inches, 8-12 feet tall. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['California Giant Mix'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-cactus-flowered-mix',
    name: 'Sunflower - Cactus Flowered Mix',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed cactus sunflower. Classic garden sunflower. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Cactus Flowered Mix'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-cactus-pink',
    name: 'Sunflower - Cactus Pink',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'pink cactus sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Cactus Pink'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-cactus-orange',
    name: 'Sunflower - Cactus Orange',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange cactus sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Cactus Orange'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-cactus-red',
    name: 'Sunflower - Cactus Red',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'red cactus sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Cactus Red'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-cactus-purple',
    name: 'Sunflower - Cactus Purple',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'purple cactus sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Cactus Purple'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-cactus-yellow',
    name: 'Sunflower - Cactus Yellow',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow cactus sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Cactus Yellow'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-oklahoma-mix',
    name: 'Sunflower - Oklahoma Mix',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed dahlia sunflower. Classic garden sunflower. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Oklahoma Mix'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-oklahoma-carmine',
    name: 'Sunflower - Oklahoma Carmine',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'carmine dahlia sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Oklahoma Carmine'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-oklahoma-salmon',
    name: 'Sunflower - Oklahoma Salmon',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'salmon dahlia sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Oklahoma Salmon'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-oklahoma-white',
    name: 'Sunflower - Oklahoma White',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'white dahlia sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Oklahoma White'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-oklahoma-golden-yellow',
    name: 'Sunflower - Oklahoma Golden Yellow',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'gold dahlia sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Oklahoma Golden Yellow'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-oklahoma-pink',
    name: 'Sunflower - Oklahoma Pink',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'pink dahlia sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Oklahoma Pink'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'zinnia-envy',
    name: 'Zinnia - Envy',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'green unusual zinnia. Classic garden zinnia. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-30 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Envy'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-queen-red-lime',
    name: 'Zinnia - Queen Red Lime',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'red lime unusual zinnia. Classic garden zinnia. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-30 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Queen Red Lime'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-queen-lime-orange',
    name: 'Zinnia - Queen Lime Orange',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'lime orange unusual zinnia. Classic garden zinnia. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-30 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Queen Lime Orange'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-queen-lime-blush',
    name: 'Zinnia - Queen Lime Blush',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'lime blush unusual zinnia. Classic garden zinnia. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-30 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Queen Lime Blush'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-zinderella-peach',
    name: 'Zinnia - Zinderella Peach',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'peach scabiosa zinnia. Pincushion centers, extra fancy. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-30 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Zinderella Peach'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-zinderella-lilac',
    name: 'Zinnia - Zinderella Lilac',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'lilac scabiosa zinnia. Pincushion centers, extra fancy. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-30 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Zinderella Lilac'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-zinderella-red',
    name: 'Zinnia - Zinderella Red',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'red scabiosa zinnia. Pincushion centers, extra fancy. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-30 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Zinderella Red'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-zinderella-orange',
    name: 'Zinnia - Zinderella Orange',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'orange scabiosa zinnia. Pincushion centers, extra fancy. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-30 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Zinderella Orange'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'sunflower-thumbelina-mix',
    name: 'Sunflower - Thumbelina Mix',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed dwarf sunflower. Compact 2-4 feet, perfect for containers. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-4 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Thumbelina Mix'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'zinnia-profusion-cherry',
    name: 'Zinnia - Profusion Cherry',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'cherry dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Profusion Cherry'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-profusion-orange',
    name: 'Zinnia - Profusion Orange',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'orange dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Profusion Orange'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-profusion-white',
    name: 'Zinnia - Profusion White',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'white dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Profusion White'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-profusion-double-hot-cherry',
    name: 'Zinnia - Profusion Double Hot Cherry',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'hot cherry dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Profusion Double Hot Cherry'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-profusion-double-deep-salmon',
    name: 'Zinnia - Profusion Double Deep Salmon',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'salmon dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Profusion Double Deep Salmon'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-magellan-cherry',
    name: 'Zinnia - Magellan Cherry',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'cherry dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Magellan Cherry'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-magellan-orange',
    name: 'Zinnia - Magellan Orange',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'orange dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Magellan Orange'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-magellan-ivory',
    name: 'Zinnia - Magellan Ivory',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'ivory dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Magellan Ivory'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-dreamland-coral',
    name: 'Zinnia - Dreamland Coral',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'coral dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Dreamland Coral'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-dreamland-red',
    name: 'Zinnia - Dreamland Red',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'red dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Dreamland Red'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-dreamland-rose',
    name: 'Zinnia - Dreamland Rose',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'rose dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Dreamland Rose'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-dreamland-yellow',
    name: 'Zinnia - Dreamland Yellow',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'yellow dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Dreamland Yellow'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-zahara-double-fire',
    name: 'Zinnia - Zahara Double Fire',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'fire dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Zahara Double Fire'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-zahara-double-strawberry',
    name: 'Zinnia - Zahara Double Strawberry',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'strawberry dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Zahara Double Strawberry'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-zahara-starlight-rose',
    name: 'Zinnia - Zahara Starlight Rose',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'rose dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Zahara Starlight Rose'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-zahara-cherry',
    name: 'Zinnia - Zahara Cherry',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'cherry dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Zahara Cherry'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-zahara-yellow',
    name: 'Zinnia - Zahara Yellow',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'yellow dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Zahara Yellow'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-zahara-white',
    name: 'Zinnia - Zahara White',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'white dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Zahara White'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-zahara-double-salmon-rose',
    name: 'Zinnia - Zahara Double Salmon Rose',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'salmon dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Zahara Double Salmon Rose'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-zahara-raspberry',
    name: 'Zinnia - Zahara Raspberry',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'raspberry dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Zahara Raspberry'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'zinnia-zahara-mixed',
    name: 'Zinnia - Zahara Mixed',
    scientificName: 'Zinnia elegans',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'mixed dwarf zinnia. Compact, perfect for borders and containers. Long bloom season, excellent cutting flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Zahara Mixed'],
    uses: ['cut flowers', 'borders', 'butterflies', 'containers']
  },
  {
    id: 'sunflower-state-fair-mix',
    name: 'Sunflower - State Fair Mix',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed tall sunflower. Classic garden sunflower. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['State Fair Mix'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-lilliput-mix',
    name: 'Sunflower - Lilliput Mix',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed pompon sunflower. Classic garden sunflower. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Lilliput Mix'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-crystal-white',
    name: 'Sunflower - Crystal White',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'white pompon sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Crystal White'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-crystal-yellow',
    name: 'Sunflower - Crystal Yellow',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'yellow pompon sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Crystal Yellow'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-crystal-orange',
    name: 'Sunflower - Crystal Orange',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange pompon sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Crystal Orange'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-old-mexico',
    name: 'Sunflower - Old Mexico',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'red single sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Old Mexico'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-persian-carpet',
    name: 'Sunflower - Persian Carpet',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'mixed single sunflower. Classic garden sunflower. Beautiful color mix.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Persian Carpet'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-red-spider',
    name: 'Sunflower - Red Spider',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'red single sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Red Spider'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-star-orange',
    name: 'Sunflower - Star Orange',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'orange single sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['Star Orange'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  },
  {
    id: 'sunflower-white-star',
    name: 'Sunflower - White Star',
    scientificName: 'Helianthus annuus',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['corn', 'cucumber'],
    enemies: ['potato', 'pole bean'],
    description: 'white single sunflower. Classic garden sunflower. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '12-24 inches',
    family: 'Asteraceae',
    varieties: ['White Star'],
    uses: ['cut flowers', 'border', 'pollinators', 'backdrops']
  }
,
  {
    id: 'marigold-african',
    name: 'Marigold - African',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'African marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['African'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-french',
    name: 'Cosmos - French',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'French cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['French'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-signet',
    name: 'Snapdragon - Signet',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Signet snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Signet'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-triploid',
    name: 'Petunia - Triploid',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Triploid petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Triploid'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-crackerjack',
    name: 'Impatiens - Crackerjack',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Crackerjack impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Crackerjack'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-inca',
    name: 'Begonia - Inca',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Inca begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Inca'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-safari',
    name: 'Geranium - Safari',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Safari geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Safari'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-taishan',
    name: 'Pansy - Taishan',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Taishan pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Taishan'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-antigua',
    name: 'Marigold - Antigua',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Antigua marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Antigua'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-bonanza',
    name: 'Cosmos - Bonanza',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Bonanza cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Bonanza'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-sensation',
    name: 'Snapdragon - Sensation',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sensation snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Sensation'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-sonata',
    name: 'Petunia - Sonata',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sonata petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Sonata'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-double-click',
    name: 'Impatiens - Double Click',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Double Click impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Double Click'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-psyche',
    name: 'Begonia - Psyche',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Psyche begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Psyche'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-xanthos',
    name: 'Geranium - Xanthos',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Xanthos geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Xanthos'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-apricotta',
    name: 'Pansy - Apricotta',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Apricotta pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Apricotta'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-cupcakes',
    name: 'Marigold - Cupcakes',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Cupcakes marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Cupcakes'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-velouette',
    name: 'Cosmos - Velouette',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Velouette cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Velouette'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-candy-stripe',
    name: 'Snapdragon - Candy Stripe',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Candy Stripe snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Candy Stripe'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-purity',
    name: 'Petunia - Purity',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Purity petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Purity'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-rocket',
    name: 'Impatiens - Rocket',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Rocket impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Rocket'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-madame-butterfly',
    name: 'Begonia - Madame Butterfly',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Madame Butterfly begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Madame Butterfly'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-twinny',
    name: 'Geranium - Twinny',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Twinny geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Twinny'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-chantilly',
    name: 'Pansy - Chantilly',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Chantilly pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Chantilly'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-liberty',
    name: 'Marigold - Liberty',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Liberty marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Liberty'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-animation',
    name: 'Cosmos - Animation',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Animation cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Animation'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-butterfly',
    name: 'Snapdragon - Butterfly',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Butterfly snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Butterfly'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-crown',
    name: 'Petunia - Crown',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Crown petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Crown'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-lipstick',
    name: 'Impatiens - Lipstick',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Lipstick impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Lipstick'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-monarch',
    name: 'Begonia - Monarch',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Monarch begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Monarch'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-night-and-day',
    name: 'Geranium - Night and Day',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Night and Day geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Night and Day'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-opus',
    name: 'Pansy - Opus',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Opus pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Opus'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-rembrandt',
    name: 'Marigold - Rembrandt',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Rembrandt marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Rembrandt'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-solstice',
    name: 'Cosmos - Solstice',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Solstice cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Solstice'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-topper',
    name: 'Snapdragon - Topper',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Topper snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Topper'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-ultra',
    name: 'Petunia - Ultra',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ultra petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Ultra'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-wave',
    name: 'Impatiens - Wave',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Wave impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Wave'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-easy-wave',
    name: 'Begonia - Easy Wave',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Easy Wave begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Easy Wave'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-shock-wave',
    name: 'Geranium - Shock Wave',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Shock Wave geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Shock Wave'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-tidal-wave',
    name: 'Pansy - Tidal Wave',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Tidal Wave pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Tidal Wave'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-supertunia',
    name: 'Marigold - Supertunia',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Supertunia marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Supertunia'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-cascadia',
    name: 'Cosmos - Cascadia',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cascadia cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Cascadia'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-explorer',
    name: 'Snapdragon - Explorer',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Explorer snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Explorer'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-prism',
    name: 'Petunia - Prism',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Prism petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Prism'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-dream',
    name: 'Impatiens - Dream',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Dream impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Dream'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-super-cascade',
    name: 'Begonia - Super Cascade',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Super Cascade begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Super Cascade'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-double-cascade',
    name: 'Geranium - Double Cascade',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Double Cascade geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Double Cascade'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-orchid-mist',
    name: 'Pansy - Orchid Mist',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Orchid Mist pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Orchid Mist'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-rose',
    name: 'Marigold - Rose',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Rose marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Rose'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-blue-vein',
    name: 'Cosmos - Blue Vein',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Blue Vein cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Blue Vein'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-super-elfin',
    name: 'Snapdragon - Super Elfin',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Super Elfin snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Super Elfin'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-divine',
    name: 'Petunia - Divine',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Divine petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Divine'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-sunpatiens',
    name: 'Impatiens - SunPatiens',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'SunPatiens impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['SunPatiens'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-new-guinea',
    name: 'Begonia - New Guinea',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'New Guinea begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['New Guinea'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-accent',
    name: 'Geranium - Accent',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Accent geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Accent'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-xtreme',
    name: 'Pansy - Xtreme',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Xtreme pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Xtreme'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-infinity',
    name: 'Marigold - Infinity',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Infinity marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Infinity'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-celebration',
    name: 'Cosmos - Celebration',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Celebration cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Celebration'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-divine',
    name: 'Snapdragon - Divine',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Divine snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Divine'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-harmony',
    name: 'Petunia - Harmony',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Harmony petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Harmony'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-dragon-wing',
    name: 'Impatiens - Dragon Wing',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Dragon Wing impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Dragon Wing'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-big',
    name: 'Begonia - Big',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Big begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Big'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-whopper',
    name: 'Geranium - Whopper',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Whopper geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Whopper'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-solenia',
    name: 'Pansy - Solenia',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Solenia pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Solenia'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-nonstop',
    name: 'Marigold - Nonstop',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Nonstop marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Nonstop'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-victory',
    name: 'Cosmos - Victory',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Victory cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Victory'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-cocktail',
    name: 'Snapdragon - Cocktail',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cocktail snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Cocktail'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-ambassador',
    name: 'Petunia - Ambassador',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ambassador petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Ambassador'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-sprint',
    name: 'Impatiens - Sprint',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sprint impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Sprint'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-ornament',
    name: 'Begonia - Ornament',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ornament begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Ornament'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-americana',
    name: 'Geranium - Americana',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Americana geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Americana'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-bullseye',
    name: 'Pansy - Bullseye',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Bullseye pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Bullseye'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-calliope',
    name: 'Marigold - Calliope',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Calliope marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Calliope'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-dynamo',
    name: 'Cosmos - Dynamo',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Dynamo cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Dynamo'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-fantasia',
    name: 'Snapdragon - Fantasia',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Fantasia snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Fantasia'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-global',
    name: 'Petunia - Global',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Global petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Global'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-horizon',
    name: 'Impatiens - Horizon',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Horizon impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Horizon'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-ivy',
    name: 'Begonia - Ivy',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ivy begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Ivy'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-maverick',
    name: 'Geranium - Maverick',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Maverick geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Maverick'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-multibloom',
    name: 'Pansy - Multibloom',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Multibloom pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Multibloom'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-orbit',
    name: 'Marigold - Orbit',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Orbit marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Orbit'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-pinto',
    name: 'Cosmos - Pinto',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Pinto cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Pinto'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-ringo',
    name: 'Snapdragon - Ringo',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ringo snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Ringo'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-sprinter',
    name: 'Petunia - Sprinter',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sprinter petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Sprinter'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-tango',
    name: 'Impatiens - Tango',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Tango impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Tango'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-tempo',
    name: 'Begonia - Tempo',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Tempo begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Tempo'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-tornado',
    name: 'Geranium - Tornado',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Tornado geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Tornado'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-universal',
    name: 'Pansy - Universal',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Universal pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Universal'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-viking',
    name: 'Marigold - Viking',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Viking marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Viking'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-wonder',
    name: 'Cosmos - Wonder',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Wonder cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Wonder'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-bingo',
    name: 'Snapdragon - Bingo',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Bingo snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Bingo'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-colossus',
    name: 'Petunia - Colossus',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Colossus petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Colossus'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-delta',
    name: 'Impatiens - Delta',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Delta impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Delta'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-fama',
    name: 'Begonia - Fama',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Fama begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Fama'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-joker',
    name: 'Geranium - Joker',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Joker geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Joker'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-majestic-giant',
    name: 'Pansy - Majestic Giant',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Majestic Giant pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Majestic Giant'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-matrix',
    name: 'Marigold - Matrix',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Matrix marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Matrix'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-moulin-rouge',
    name: 'Cosmos - Moulin Rouge',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Moulin Rouge cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Moulin Rouge'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-nature',
    name: 'Snapdragon - Nature',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Nature snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Nature'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-premier',
    name: 'Petunia - Premier',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Premier petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Premier'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-spring',
    name: 'Impatiens - Spring',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Spring impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Spring'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-ultima',
    name: 'Begonia - Ultima',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ultima begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Ultima'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-universal-plus',
    name: 'Geranium - Universal Plus',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Universal Plus geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Universal Plus'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-velvet',
    name: 'Pansy - Velvet',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Velvet pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Velvet'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-winter',
    name: 'Marigold - Winter',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Winter marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Winter'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-african-2',
    name: 'Cosmos - African 2',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'African 2 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['African 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-french-2',
    name: 'Snapdragon - French 2',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'French 2 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['French 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-signet-2',
    name: 'Petunia - Signet 2',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Signet 2 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Signet 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-triploid-2',
    name: 'Impatiens - Triploid 2',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Triploid 2 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Triploid 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-crackerjack-2',
    name: 'Begonia - Crackerjack 2',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Crackerjack 2 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Crackerjack 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-inca-2',
    name: 'Geranium - Inca 2',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Inca 2 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Inca 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-safari-2',
    name: 'Pansy - Safari 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Safari 2 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Safari 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-taishan-2',
    name: 'Marigold - Taishan 2',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Taishan 2 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Taishan 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-antigua-2',
    name: 'Cosmos - Antigua 2',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Antigua 2 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Antigua 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-bonanza-2',
    name: 'Snapdragon - Bonanza 2',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Bonanza 2 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Bonanza 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-sensation-2',
    name: 'Petunia - Sensation 2',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sensation 2 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Sensation 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-sonata-2',
    name: 'Impatiens - Sonata 2',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sonata 2 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Sonata 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-double-click-2',
    name: 'Begonia - Double Click 2',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Double Click 2 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Double Click 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-psyche-2',
    name: 'Geranium - Psyche 2',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Psyche 2 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Psyche 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-xanthos-2',
    name: 'Pansy - Xanthos 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Xanthos 2 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Xanthos 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-apricotta-2',
    name: 'Marigold - Apricotta 2',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Apricotta 2 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Apricotta 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-cupcakes-2',
    name: 'Cosmos - Cupcakes 2',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cupcakes 2 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Cupcakes 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-velouette-2',
    name: 'Snapdragon - Velouette 2',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Velouette 2 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Velouette 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-candy-stripe-2',
    name: 'Petunia - Candy Stripe 2',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Candy Stripe 2 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Candy Stripe 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-purity-2',
    name: 'Impatiens - Purity 2',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Purity 2 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Purity 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-rocket-2',
    name: 'Begonia - Rocket 2',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Rocket 2 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Rocket 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-madame-butterfly-2',
    name: 'Geranium - Madame Butterfly 2',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Madame Butterfly 2 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Madame Butterfly 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-twinny-2',
    name: 'Pansy - Twinny 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Twinny 2 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Twinny 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-chantilly-2',
    name: 'Marigold - Chantilly 2',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Chantilly 2 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Chantilly 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-liberty-2',
    name: 'Cosmos - Liberty 2',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Liberty 2 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Liberty 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-animation-2',
    name: 'Snapdragon - Animation 2',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Animation 2 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Animation 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-butterfly-2',
    name: 'Petunia - Butterfly 2',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Butterfly 2 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Butterfly 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-crown-2',
    name: 'Impatiens - Crown 2',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Crown 2 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Crown 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-lipstick-2',
    name: 'Begonia - Lipstick 2',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Lipstick 2 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Lipstick 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-monarch-2',
    name: 'Geranium - Monarch 2',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Monarch 2 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Monarch 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-night-and-day-2',
    name: 'Pansy - Night and Day 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Night and Day 2 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Night and Day 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-opus-2',
    name: 'Marigold - Opus 2',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Opus 2 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Opus 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-rembrandt-2',
    name: 'Cosmos - Rembrandt 2',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Rembrandt 2 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Rembrandt 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-solstice-2',
    name: 'Snapdragon - Solstice 2',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Solstice 2 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Solstice 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-topper-2',
    name: 'Petunia - Topper 2',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Topper 2 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Topper 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-ultra-2',
    name: 'Impatiens - Ultra 2',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ultra 2 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Ultra 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-wave-2',
    name: 'Begonia - Wave 2',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Wave 2 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Wave 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-easy-wave-2',
    name: 'Geranium - Easy Wave 2',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Easy Wave 2 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Easy Wave 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-shock-wave-2',
    name: 'Pansy - Shock Wave 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Shock Wave 2 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Shock Wave 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-tidal-wave-2',
    name: 'Marigold - Tidal Wave 2',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Tidal Wave 2 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Tidal Wave 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-supertunia-2',
    name: 'Cosmos - Supertunia 2',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Supertunia 2 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Supertunia 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-cascadia-2',
    name: 'Snapdragon - Cascadia 2',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cascadia 2 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Cascadia 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-explorer-2',
    name: 'Petunia - Explorer 2',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Explorer 2 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Explorer 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-prism-2',
    name: 'Impatiens - Prism 2',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Prism 2 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Prism 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-dream-2',
    name: 'Begonia - Dream 2',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Dream 2 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Dream 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-super-cascade-2',
    name: 'Geranium - Super Cascade 2',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Super Cascade 2 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Super Cascade 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-double-cascade-2',
    name: 'Pansy - Double Cascade 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Double Cascade 2 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Double Cascade 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-orchid-mist-2',
    name: 'Marigold - Orchid Mist 2',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Orchid Mist 2 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Orchid Mist 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-rose-2',
    name: 'Cosmos - Rose 2',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Rose 2 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Rose 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-blue-vein-2',
    name: 'Snapdragon - Blue Vein 2',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Blue Vein 2 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Blue Vein 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-super-elfin-2',
    name: 'Petunia - Super Elfin 2',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Super Elfin 2 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Super Elfin 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-divine-2',
    name: 'Impatiens - Divine 2',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Divine 2 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Divine 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-sunpatiens-2',
    name: 'Begonia - SunPatiens 2',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'SunPatiens 2 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['SunPatiens 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-new-guinea-2',
    name: 'Geranium - New Guinea 2',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'New Guinea 2 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['New Guinea 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-accent-2',
    name: 'Pansy - Accent 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Accent 2 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Accent 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-xtreme-2',
    name: 'Marigold - Xtreme 2',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Xtreme 2 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Xtreme 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-infinity-2',
    name: 'Cosmos - Infinity 2',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Infinity 2 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Infinity 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-celebration-2',
    name: 'Snapdragon - Celebration 2',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Celebration 2 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Celebration 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-divine-2',
    name: 'Petunia - Divine 2',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Divine 2 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Divine 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-harmony-2',
    name: 'Impatiens - Harmony 2',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Harmony 2 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Harmony 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-dragon-wing-2',
    name: 'Begonia - Dragon Wing 2',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Dragon Wing 2 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Dragon Wing 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-big-2',
    name: 'Geranium - Big 2',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Big 2 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Big 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-whopper-2',
    name: 'Pansy - Whopper 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Whopper 2 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Whopper 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-solenia-2',
    name: 'Marigold - Solenia 2',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Solenia 2 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Solenia 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-nonstop-2',
    name: 'Cosmos - Nonstop 2',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Nonstop 2 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Nonstop 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-victory-2',
    name: 'Snapdragon - Victory 2',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Victory 2 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Victory 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-cocktail-2',
    name: 'Petunia - Cocktail 2',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cocktail 2 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Cocktail 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-ambassador-2',
    name: 'Impatiens - Ambassador 2',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ambassador 2 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Ambassador 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-sprint-2',
    name: 'Begonia - Sprint 2',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sprint 2 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Sprint 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-ornament-2',
    name: 'Geranium - Ornament 2',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ornament 2 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Ornament 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-americana-2',
    name: 'Pansy - Americana 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Americana 2 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Americana 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-bullseye-2',
    name: 'Marigold - Bullseye 2',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Bullseye 2 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Bullseye 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-calliope-2',
    name: 'Cosmos - Calliope 2',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Calliope 2 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Calliope 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-dynamo-2',
    name: 'Snapdragon - Dynamo 2',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Dynamo 2 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Dynamo 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-fantasia-2',
    name: 'Petunia - Fantasia 2',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Fantasia 2 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Fantasia 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-global-2',
    name: 'Impatiens - Global 2',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Global 2 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Global 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-horizon-2',
    name: 'Begonia - Horizon 2',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Horizon 2 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Horizon 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-ivy-2',
    name: 'Geranium - Ivy 2',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ivy 2 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Ivy 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-maverick-2',
    name: 'Pansy - Maverick 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Maverick 2 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Maverick 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-multibloom-2',
    name: 'Marigold - Multibloom 2',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Multibloom 2 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Multibloom 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-orbit-2',
    name: 'Cosmos - Orbit 2',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Orbit 2 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Orbit 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-pinto-2',
    name: 'Snapdragon - Pinto 2',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Pinto 2 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Pinto 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-ringo-2',
    name: 'Petunia - Ringo 2',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ringo 2 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Ringo 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-sprinter-2',
    name: 'Impatiens - Sprinter 2',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sprinter 2 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Sprinter 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-tango-2',
    name: 'Begonia - Tango 2',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Tango 2 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Tango 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-tempo-2',
    name: 'Geranium - Tempo 2',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Tempo 2 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Tempo 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-tornado-2',
    name: 'Pansy - Tornado 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Tornado 2 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Tornado 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-universal-2',
    name: 'Marigold - Universal 2',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Universal 2 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Universal 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-viking-2',
    name: 'Cosmos - Viking 2',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Viking 2 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Viking 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-wonder-2',
    name: 'Snapdragon - Wonder 2',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Wonder 2 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Wonder 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-bingo-2',
    name: 'Petunia - Bingo 2',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Bingo 2 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Bingo 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-colossus-2',
    name: 'Impatiens - Colossus 2',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Colossus 2 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Colossus 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-delta-2',
    name: 'Begonia - Delta 2',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Delta 2 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Delta 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-fama-2',
    name: 'Geranium - Fama 2',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Fama 2 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Fama 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-joker-2',
    name: 'Pansy - Joker 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Joker 2 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Joker 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-majestic-giant-2',
    name: 'Marigold - Majestic Giant 2',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Majestic Giant 2 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Majestic Giant 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-matrix-2',
    name: 'Cosmos - Matrix 2',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Matrix 2 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Matrix 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-moulin-rouge-2',
    name: 'Snapdragon - Moulin Rouge 2',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Moulin Rouge 2 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Moulin Rouge 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-nature-2',
    name: 'Petunia - Nature 2',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Nature 2 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Nature 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-premier-2',
    name: 'Impatiens - Premier 2',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Premier 2 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Premier 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-spring-2',
    name: 'Begonia - Spring 2',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Spring 2 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Spring 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-ultima-2',
    name: 'Geranium - Ultima 2',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ultima 2 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Ultima 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-universal-plus-2',
    name: 'Pansy - Universal Plus 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Universal Plus 2 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Universal Plus 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-velvet-2',
    name: 'Marigold - Velvet 2',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Velvet 2 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Velvet 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-winter-2',
    name: 'Cosmos - Winter 2',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Winter 2 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Winter 2'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-african-3',
    name: 'Snapdragon - African 3',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'African 3 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['African 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-french-3',
    name: 'Petunia - French 3',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'French 3 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['French 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-signet-3',
    name: 'Impatiens - Signet 3',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Signet 3 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Signet 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-triploid-3',
    name: 'Begonia - Triploid 3',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Triploid 3 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Triploid 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-crackerjack-3',
    name: 'Geranium - Crackerjack 3',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Crackerjack 3 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Crackerjack 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-inca-3',
    name: 'Pansy - Inca 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Inca 3 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Inca 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-safari-3',
    name: 'Marigold - Safari 3',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Safari 3 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Safari 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-taishan-3',
    name: 'Cosmos - Taishan 3',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Taishan 3 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Taishan 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-antigua-3',
    name: 'Snapdragon - Antigua 3',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Antigua 3 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Antigua 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-bonanza-3',
    name: 'Petunia - Bonanza 3',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Bonanza 3 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Bonanza 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-sensation-3',
    name: 'Impatiens - Sensation 3',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sensation 3 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Sensation 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-sonata-3',
    name: 'Begonia - Sonata 3',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sonata 3 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Sonata 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-double-click-3',
    name: 'Geranium - Double Click 3',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Double Click 3 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Double Click 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-psyche-3',
    name: 'Pansy - Psyche 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Psyche 3 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Psyche 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-xanthos-3',
    name: 'Marigold - Xanthos 3',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Xanthos 3 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Xanthos 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-apricotta-3',
    name: 'Cosmos - Apricotta 3',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Apricotta 3 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Apricotta 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-cupcakes-3',
    name: 'Snapdragon - Cupcakes 3',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cupcakes 3 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Cupcakes 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-velouette-3',
    name: 'Petunia - Velouette 3',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Velouette 3 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Velouette 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-candy-stripe-3',
    name: 'Impatiens - Candy Stripe 3',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Candy Stripe 3 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Candy Stripe 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-purity-3',
    name: 'Begonia - Purity 3',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Purity 3 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Purity 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-rocket-3',
    name: 'Geranium - Rocket 3',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Rocket 3 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Rocket 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-madame-butterfly-3',
    name: 'Pansy - Madame Butterfly 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Madame Butterfly 3 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Madame Butterfly 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-twinny-3',
    name: 'Marigold - Twinny 3',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Twinny 3 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Twinny 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-chantilly-3',
    name: 'Cosmos - Chantilly 3',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Chantilly 3 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Chantilly 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-liberty-3',
    name: 'Snapdragon - Liberty 3',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Liberty 3 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Liberty 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-animation-3',
    name: 'Petunia - Animation 3',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Animation 3 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Animation 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-butterfly-3',
    name: 'Impatiens - Butterfly 3',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Butterfly 3 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Butterfly 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-crown-3',
    name: 'Begonia - Crown 3',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Crown 3 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Crown 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-lipstick-3',
    name: 'Geranium - Lipstick 3',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Lipstick 3 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Lipstick 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-monarch-3',
    name: 'Pansy - Monarch 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Monarch 3 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Monarch 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-night-and-day-3',
    name: 'Marigold - Night and Day 3',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Night and Day 3 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Night and Day 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-opus-3',
    name: 'Cosmos - Opus 3',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Opus 3 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Opus 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-rembrandt-3',
    name: 'Snapdragon - Rembrandt 3',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Rembrandt 3 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Rembrandt 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-solstice-3',
    name: 'Petunia - Solstice 3',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Solstice 3 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Solstice 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-topper-3',
    name: 'Impatiens - Topper 3',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Topper 3 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Topper 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-ultra-3',
    name: 'Begonia - Ultra 3',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ultra 3 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Ultra 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-wave-3',
    name: 'Geranium - Wave 3',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Wave 3 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Wave 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-easy-wave-3',
    name: 'Pansy - Easy Wave 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Easy Wave 3 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Easy Wave 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-shock-wave-3',
    name: 'Marigold - Shock Wave 3',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Shock Wave 3 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Shock Wave 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-tidal-wave-3',
    name: 'Cosmos - Tidal Wave 3',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Tidal Wave 3 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Tidal Wave 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-supertunia-3',
    name: 'Snapdragon - Supertunia 3',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Supertunia 3 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Supertunia 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-cascadia-3',
    name: 'Petunia - Cascadia 3',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cascadia 3 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Cascadia 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-explorer-3',
    name: 'Impatiens - Explorer 3',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Explorer 3 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Explorer 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-prism-3',
    name: 'Begonia - Prism 3',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Prism 3 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Prism 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-dream-3',
    name: 'Geranium - Dream 3',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Dream 3 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Dream 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-super-cascade-3',
    name: 'Pansy - Super Cascade 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Super Cascade 3 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Super Cascade 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-double-cascade-3',
    name: 'Marigold - Double Cascade 3',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Double Cascade 3 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Double Cascade 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-orchid-mist-3',
    name: 'Cosmos - Orchid Mist 3',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Orchid Mist 3 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Orchid Mist 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-rose-3',
    name: 'Snapdragon - Rose 3',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Rose 3 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Rose 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-blue-vein-3',
    name: 'Petunia - Blue Vein 3',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Blue Vein 3 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Blue Vein 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-super-elfin-3',
    name: 'Impatiens - Super Elfin 3',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Super Elfin 3 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Super Elfin 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-divine-3',
    name: 'Begonia - Divine 3',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Divine 3 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Divine 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-sunpatiens-3',
    name: 'Geranium - SunPatiens 3',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'SunPatiens 3 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['SunPatiens 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-new-guinea-3',
    name: 'Pansy - New Guinea 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'New Guinea 3 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['New Guinea 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-accent-3',
    name: 'Marigold - Accent 3',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Accent 3 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Accent 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-xtreme-3',
    name: 'Cosmos - Xtreme 3',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Xtreme 3 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Xtreme 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-infinity-3',
    name: 'Snapdragon - Infinity 3',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Infinity 3 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Infinity 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-celebration-3',
    name: 'Petunia - Celebration 3',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Celebration 3 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Celebration 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-divine-3',
    name: 'Impatiens - Divine 3',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Divine 3 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Divine 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-harmony-3',
    name: 'Begonia - Harmony 3',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Harmony 3 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Harmony 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-dragon-wing-3',
    name: 'Geranium - Dragon Wing 3',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Dragon Wing 3 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Dragon Wing 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-big-3',
    name: 'Pansy - Big 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Big 3 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Big 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-whopper-3',
    name: 'Marigold - Whopper 3',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Whopper 3 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Whopper 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-solenia-3',
    name: 'Cosmos - Solenia 3',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Solenia 3 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Solenia 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-nonstop-3',
    name: 'Snapdragon - Nonstop 3',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Nonstop 3 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Nonstop 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-victory-3',
    name: 'Petunia - Victory 3',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Victory 3 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Victory 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-cocktail-3',
    name: 'Impatiens - Cocktail 3',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cocktail 3 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Cocktail 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-ambassador-3',
    name: 'Begonia - Ambassador 3',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ambassador 3 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Ambassador 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-sprint-3',
    name: 'Geranium - Sprint 3',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sprint 3 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Sprint 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-ornament-3',
    name: 'Pansy - Ornament 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ornament 3 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Ornament 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-americana-3',
    name: 'Marigold - Americana 3',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Americana 3 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Americana 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-bullseye-3',
    name: 'Cosmos - Bullseye 3',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Bullseye 3 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Bullseye 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-calliope-3',
    name: 'Snapdragon - Calliope 3',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Calliope 3 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Calliope 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-dynamo-3',
    name: 'Petunia - Dynamo 3',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Dynamo 3 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Dynamo 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-fantasia-3',
    name: 'Impatiens - Fantasia 3',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Fantasia 3 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Fantasia 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-global-3',
    name: 'Begonia - Global 3',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Global 3 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Global 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-horizon-3',
    name: 'Geranium - Horizon 3',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Horizon 3 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Horizon 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-ivy-3',
    name: 'Pansy - Ivy 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ivy 3 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Ivy 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-maverick-3',
    name: 'Marigold - Maverick 3',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Maverick 3 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Maverick 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-multibloom-3',
    name: 'Cosmos - Multibloom 3',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Multibloom 3 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Multibloom 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-orbit-3',
    name: 'Snapdragon - Orbit 3',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Orbit 3 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Orbit 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-pinto-3',
    name: 'Petunia - Pinto 3',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Pinto 3 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Pinto 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-ringo-3',
    name: 'Impatiens - Ringo 3',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ringo 3 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Ringo 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-sprinter-3',
    name: 'Begonia - Sprinter 3',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sprinter 3 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Sprinter 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-tango-3',
    name: 'Geranium - Tango 3',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Tango 3 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Tango 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-tempo-3',
    name: 'Pansy - Tempo 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Tempo 3 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Tempo 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-tornado-3',
    name: 'Marigold - Tornado 3',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Tornado 3 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Tornado 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-universal-3',
    name: 'Cosmos - Universal 3',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Universal 3 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Universal 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-viking-3',
    name: 'Snapdragon - Viking 3',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Viking 3 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Viking 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-wonder-3',
    name: 'Petunia - Wonder 3',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Wonder 3 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Wonder 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-bingo-3',
    name: 'Impatiens - Bingo 3',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Bingo 3 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Bingo 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-colossus-3',
    name: 'Begonia - Colossus 3',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Colossus 3 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Colossus 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-delta-3',
    name: 'Geranium - Delta 3',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Delta 3 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Delta 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-fama-3',
    name: 'Pansy - Fama 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Fama 3 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Fama 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-joker-3',
    name: 'Marigold - Joker 3',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Joker 3 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Joker 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-majestic-giant-3',
    name: 'Cosmos - Majestic Giant 3',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Majestic Giant 3 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Majestic Giant 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-matrix-3',
    name: 'Snapdragon - Matrix 3',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Matrix 3 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Matrix 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-moulin-rouge-3',
    name: 'Petunia - Moulin Rouge 3',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Moulin Rouge 3 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Moulin Rouge 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-nature-3',
    name: 'Impatiens - Nature 3',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Nature 3 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Nature 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-premier-3',
    name: 'Begonia - Premier 3',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Premier 3 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Premier 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-spring-3',
    name: 'Geranium - Spring 3',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Spring 3 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Spring 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-ultima-3',
    name: 'Pansy - Ultima 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ultima 3 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Ultima 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-universal-plus-3',
    name: 'Marigold - Universal Plus 3',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Universal Plus 3 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Universal Plus 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-velvet-3',
    name: 'Cosmos - Velvet 3',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Velvet 3 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Velvet 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-winter-3',
    name: 'Snapdragon - Winter 3',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Winter 3 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Winter 3'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-african-4',
    name: 'Petunia - African 4',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'African 4 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['African 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-french-4',
    name: 'Impatiens - French 4',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'French 4 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['French 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-signet-4',
    name: 'Begonia - Signet 4',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Signet 4 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Signet 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-triploid-4',
    name: 'Geranium - Triploid 4',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Triploid 4 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Triploid 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-crackerjack-4',
    name: 'Pansy - Crackerjack 4',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Crackerjack 4 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Crackerjack 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-inca-4',
    name: 'Marigold - Inca 4',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Inca 4 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Inca 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-safari-4',
    name: 'Cosmos - Safari 4',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Safari 4 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Safari 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-taishan-4',
    name: 'Snapdragon - Taishan 4',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Taishan 4 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Taishan 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-antigua-4',
    name: 'Petunia - Antigua 4',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Antigua 4 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Antigua 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-bonanza-4',
    name: 'Impatiens - Bonanza 4',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Bonanza 4 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Bonanza 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-sensation-4',
    name: 'Begonia - Sensation 4',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sensation 4 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Sensation 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-sonata-4',
    name: 'Geranium - Sonata 4',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sonata 4 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Sonata 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-double-click-4',
    name: 'Pansy - Double Click 4',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Double Click 4 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Double Click 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-psyche-4',
    name: 'Marigold - Psyche 4',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Psyche 4 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Psyche 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-xanthos-4',
    name: 'Cosmos - Xanthos 4',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Xanthos 4 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Xanthos 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-apricotta-4',
    name: 'Snapdragon - Apricotta 4',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Apricotta 4 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Apricotta 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-cupcakes-4',
    name: 'Petunia - Cupcakes 4',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cupcakes 4 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Cupcakes 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-velouette-4',
    name: 'Impatiens - Velouette 4',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Velouette 4 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Velouette 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-candy-stripe-4',
    name: 'Begonia - Candy Stripe 4',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Candy Stripe 4 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Candy Stripe 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-purity-4',
    name: 'Geranium - Purity 4',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Purity 4 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Purity 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-rocket-4',
    name: 'Pansy - Rocket 4',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Rocket 4 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Rocket 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-madame-butterfly-4',
    name: 'Marigold - Madame Butterfly 4',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Madame Butterfly 4 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Madame Butterfly 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-twinny-4',
    name: 'Cosmos - Twinny 4',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Twinny 4 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Twinny 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-chantilly-4',
    name: 'Snapdragon - Chantilly 4',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Chantilly 4 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Chantilly 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-liberty-4',
    name: 'Petunia - Liberty 4',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Liberty 4 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Liberty 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-animation-4',
    name: 'Impatiens - Animation 4',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Animation 4 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Animation 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-butterfly-4',
    name: 'Begonia - Butterfly 4',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Butterfly 4 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Butterfly 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-crown-4',
    name: 'Geranium - Crown 4',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Crown 4 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Crown 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-lipstick-4',
    name: 'Pansy - Lipstick 4',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Lipstick 4 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Lipstick 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-monarch-4',
    name: 'Marigold - Monarch 4',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Monarch 4 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Monarch 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-night-and-day-4',
    name: 'Cosmos - Night and Day 4',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Night and Day 4 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Night and Day 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-opus-4',
    name: 'Snapdragon - Opus 4',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Opus 4 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Opus 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-rembrandt-4',
    name: 'Petunia - Rembrandt 4',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Rembrandt 4 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Rembrandt 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-solstice-4',
    name: 'Impatiens - Solstice 4',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Solstice 4 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Solstice 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-topper-4',
    name: 'Begonia - Topper 4',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Topper 4 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Topper 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-ultra-4',
    name: 'Geranium - Ultra 4',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ultra 4 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Ultra 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-wave-4',
    name: 'Pansy - Wave 4',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Wave 4 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Wave 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-easy-wave-4',
    name: 'Marigold - Easy Wave 4',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Easy Wave 4 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Easy Wave 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-shock-wave-4',
    name: 'Cosmos - Shock Wave 4',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Shock Wave 4 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Shock Wave 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-tidal-wave-4',
    name: 'Snapdragon - Tidal Wave 4',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Tidal Wave 4 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Tidal Wave 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-supertunia-4',
    name: 'Petunia - Supertunia 4',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Supertunia 4 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Supertunia 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-cascadia-4',
    name: 'Impatiens - Cascadia 4',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cascadia 4 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Cascadia 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-explorer-4',
    name: 'Begonia - Explorer 4',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Explorer 4 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Explorer 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-prism-4',
    name: 'Geranium - Prism 4',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Prism 4 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Prism 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-dream-4',
    name: 'Pansy - Dream 4',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Dream 4 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Dream 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-super-cascade-4',
    name: 'Marigold - Super Cascade 4',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Super Cascade 4 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Super Cascade 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-double-cascade-4',
    name: 'Cosmos - Double Cascade 4',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Double Cascade 4 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Double Cascade 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-orchid-mist-4',
    name: 'Snapdragon - Orchid Mist 4',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Orchid Mist 4 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Orchid Mist 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-rose-4',
    name: 'Petunia - Rose 4',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Rose 4 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Rose 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-blue-vein-4',
    name: 'Impatiens - Blue Vein 4',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Blue Vein 4 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Blue Vein 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-super-elfin-4',
    name: 'Begonia - Super Elfin 4',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Super Elfin 4 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Super Elfin 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-divine-4',
    name: 'Geranium - Divine 4',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Divine 4 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Divine 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-sunpatiens-4',
    name: 'Pansy - SunPatiens 4',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'SunPatiens 4 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['SunPatiens 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-new-guinea-4',
    name: 'Marigold - New Guinea 4',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'New Guinea 4 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['New Guinea 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-accent-4',
    name: 'Cosmos - Accent 4',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Accent 4 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Accent 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-xtreme-4',
    name: 'Snapdragon - Xtreme 4',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Xtreme 4 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Xtreme 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-infinity-4',
    name: 'Petunia - Infinity 4',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Infinity 4 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Infinity 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-celebration-4',
    name: 'Impatiens - Celebration 4',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Celebration 4 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Celebration 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-divine-4',
    name: 'Begonia - Divine 4',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Divine 4 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Divine 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-harmony-4',
    name: 'Geranium - Harmony 4',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Harmony 4 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Harmony 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-dragon-wing-4',
    name: 'Pansy - Dragon Wing 4',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Dragon Wing 4 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Dragon Wing 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-big-4',
    name: 'Marigold - Big 4',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Big 4 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Big 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-whopper-4',
    name: 'Cosmos - Whopper 4',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Whopper 4 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Whopper 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-solenia-4',
    name: 'Snapdragon - Solenia 4',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Solenia 4 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Solenia 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-nonstop-4',
    name: 'Petunia - Nonstop 4',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Nonstop 4 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Nonstop 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-victory-4',
    name: 'Impatiens - Victory 4',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Victory 4 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Victory 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-cocktail-4',
    name: 'Begonia - Cocktail 4',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cocktail 4 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Cocktail 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-ambassador-4',
    name: 'Geranium - Ambassador 4',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ambassador 4 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Ambassador 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-sprint-4',
    name: 'Pansy - Sprint 4',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sprint 4 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Sprint 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-ornament-4',
    name: 'Marigold - Ornament 4',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Ornament 4 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Ornament 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-americana-4',
    name: 'Cosmos - Americana 4',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Americana 4 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Americana 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-bullseye-4',
    name: 'Snapdragon - Bullseye 4',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Bullseye 4 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Bullseye 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-calliope-4',
    name: 'Petunia - Calliope 4',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Calliope 4 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Calliope 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-dynamo-4',
    name: 'Impatiens - Dynamo 4',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Dynamo 4 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Dynamo 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-fantasia-4',
    name: 'Begonia - Fantasia 4',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Fantasia 4 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Fantasia 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-global-4',
    name: 'Geranium - Global 4',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Global 4 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Global 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-horizon-4',
    name: 'Pansy - Horizon 4',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Horizon 4 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Horizon 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'marigold-ivy-4',
    name: 'Marigold - Ivy 4',
    scientificName: 'Tagetes spp',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: [],
    description: 'Ivy 4 marigold. Bright colors, repels pests, easy to grow.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '10-18 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Ivy 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'cosmos-maverick-4',
    name: 'Cosmos - Maverick 4',
    scientificName: 'Cosmos bipinnatus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Maverick 4 cosmos. Delicate daisy-like flowers, attracts butterflies.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '36-48 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Maverick 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'snapdragon-multibloom-4',
    name: 'Snapdragon - Multibloom 4',
    scientificName: 'Antirrhinum majus',
    category: 'flower',
    spacing: 10,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Multibloom 4 snapdragon. Spiky blooms in many colors, great for cutting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-30 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Multibloom 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'petunia-orbit-4',
    name: 'Petunia - Orbit 4',
    scientificName: 'Petunia x hybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Orbit 4 petunia. Cascading or upright, profuse bloomer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Solanaceae',
    varieties: ['Orbit 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'impatiens-pinto-4',
    name: 'Impatiens - Pinto 4',
    scientificName: 'Impatiens walleriana',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Pinto 4 impatiens. Shade-loving, continuous color.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Balsaminaceae',
    varieties: ['Pinto 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'begonia-ringo-4',
    name: 'Begonia - Ringo 4',
    scientificName: 'Begonia x tuberhybrida',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ringo 4 begonia. Waxy flowers, shade tolerant.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Begoniaceae',
    varieties: ['Ringo 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'geranium-sprinter-4',
    name: 'Geranium - Sprinter 4',
    scientificName: 'Pelargonium x hortorum',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sprinter 4 geranium. Classic garden flower, scented leaves.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Geraniaceae',
    varieties: ['Sprinter 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  },
  {
    id: 'pansy-tango-4',
    name: 'Pansy - Tango 4',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Tango 4 pansy. Cheerful faces, cool weather favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-14 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Tango 4'],
    uses: ['beds', 'borders', 'containers', 'cut flowers']
  }
,
  {
    id: 'nasturtium-jewel-mix',
    name: 'Nasturtium - Jewel Mix',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Jewel Mix nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Jewel Mix'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-alaska',
    name: 'Borage - Alaska',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Alaska borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Alaska'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-empress',
    name: 'Calendula - Empress',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Empress calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Empress'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-moonlight',
    name: 'Viola - Moonlight',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Moonlight viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Moonlight'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-whirlybird',
    name: 'Pansy - Whirlybird',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Whirlybird pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Whirlybird'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-peach-melba',
    name: 'Johnny jump up - Peach Melba',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Peach Melba johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Peach Melba'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-canary-creeper',
    name: 'Chive blossom - Canary Creeper',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Canary Creeper chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Canary Creeper'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-spitfire',
    name: 'Squash blossom - Spitfire',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Spitfire squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Spitfire'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-troika',
    name: 'Elderflower - Troika',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Troika elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Troika'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-golden',
    name: 'Rose - Golden',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Golden rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Golden'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-blue',
    name: 'Nasturtium - Blue',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Blue nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Blue'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-white',
    name: 'Borage - White',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'White borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['White'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-purple',
    name: 'Calendula - Purple',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Purple calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Purple'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-pink',
    name: 'Viola - Pink',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Pink viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Pink'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-lavender',
    name: 'Pansy - Lavender',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Lavender pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Lavender'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-pacific-beauty',
    name: 'Johnny jump up - Pacific Beauty',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Pacific Beauty johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Pacific Beauty'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-resina',
    name: 'Chive blossom - Resina',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Resina chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Resina'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-radio',
    name: 'Squash blossom - Radio',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Radio squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Radio'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-bronze',
    name: 'Elderflower - Bronze',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Bronze elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Bronze'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-pink-surprise',
    name: 'Rose - Pink Surprise',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Pink Surprise rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Pink Surprise'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-sorbet',
    name: 'Nasturtium - Sorbet',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Sorbet nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Sorbet'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-penny',
    name: 'Borage - Penny',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Penny borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Penny'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-majestic-giants',
    name: 'Calendula - Majestic Giants',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Majestic Giants calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Majestic Giants'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-colossus',
    name: 'Viola - Colossus',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Colossus viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Colossus'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-delta',
    name: 'Pansy - Delta',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Delta pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Delta'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-johnny-jump-up',
    name: 'Johnny jump up - Johnny Jump Up',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Johnny Jump Up johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Johnny Jump Up'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-helen-mount',
    name: 'Chive blossom - Helen Mount',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Helen Mount chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Helen Mount'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-wild-pansy',
    name: 'Squash blossom - Wild Pansy',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Wild Pansy squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Wild Pansy'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-heartsease',
    name: 'Elderflower - Heartsease',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Heartsease elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Heartsease'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-field',
    name: 'Rose - Field',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Field rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Field'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-garlic',
    name: 'Nasturtium - Garlic',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Garlic nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Garlic'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-onion',
    name: 'Borage - Onion',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Onion borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Onion'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-chinese',
    name: 'Calendula - Chinese',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Chinese calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Chinese'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-siberian',
    name: 'Viola - Siberian',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Siberian viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Siberian'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-giant',
    name: 'Pansy - Giant',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Giant pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Giant'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-zucchini',
    name: 'Johnny jump up - Zucchini',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Zucchini johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Zucchini'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-pumpkin',
    name: 'Chive blossom - Pumpkin',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Pumpkin chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Pumpkin'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-squash',
    name: 'Squash blossom - Squash',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Squash squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Squash'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-summer',
    name: 'Elderflower - Summer',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Summer elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Summer'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-winter',
    name: 'Rose - Winter',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Winter rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Winter'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-black-lace',
    name: 'Nasturtium - Black Lace',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Black Lace nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Black Lace'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-sambucus',
    name: 'Borage - Sambucus',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Sambucus borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Sambucus'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-american',
    name: 'Calendula - American',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'American calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['American'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-european',
    name: 'Viola - European',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'European viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['European'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-blue',
    name: 'Pansy - Blue',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Blue pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Blue'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-damask',
    name: 'Johnny jump up - Damask',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Damask johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Damask'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-tea',
    name: 'Chive blossom - Tea',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Tea chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Tea'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-floribunda',
    name: 'Squash blossom - Floribunda',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Floribunda squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Floribunda'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-grandiflora',
    name: 'Elderflower - Grandiflora',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Grandiflora elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Grandiflora'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-climbing',
    name: 'Rose - Climbing',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Climbing rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Climbing'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-heritage',
    name: 'Nasturtium - Heritage',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Heritage nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Heritage'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-old-garden',
    name: 'Borage - Old Garden',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Old Garden borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Old Garden'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-species',
    name: 'Calendula - Species',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Species calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Species'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-miniature',
    name: 'Viola - Miniature',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Miniature viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Miniature'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-ground-cover',
    name: 'Pansy - Ground Cover',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ground Cover pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Ground Cover'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-red',
    name: 'Johnny jump up - Red',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Red johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Red'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-orange',
    name: 'Chive blossom - Orange',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Orange chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Orange'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-yellow',
    name: 'Squash blossom - Yellow',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Yellow squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Yellow'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-cream',
    name: 'Elderflower - Cream',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cream elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Cream'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-apricot',
    name: 'Rose - Apricot',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Apricot rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Apricot'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-coral',
    name: 'Nasturtium - Coral',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Coral nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Coral'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-salmon',
    name: 'Borage - Salmon',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Salmon borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Salmon'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-peach',
    name: 'Calendula - Peach',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Peach calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Peach'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-mango',
    name: 'Viola - Mango',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Mango viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Mango'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-tangerine',
    name: 'Pansy - Tangerine',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Tangerine pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Tangerine'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-gold',
    name: 'Johnny jump up - Gold',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Gold johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Gold'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-lemon',
    name: 'Chive blossom - Lemon',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Lemon chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Lemon'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-butter',
    name: 'Squash blossom - Butter',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Butter squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Butter'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-canary',
    name: 'Elderflower - Canary',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Canary elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Canary'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-maize',
    name: 'Rose - Maize',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Maize rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Maize'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-chartreuse',
    name: 'Nasturtium - Chartreuse',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Chartreuse nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Chartreuse'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-lime',
    name: 'Borage - Lime',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Lime borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Lime'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-green',
    name: 'Calendula - Green',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Green calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Green'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-mint',
    name: 'Viola - Mint',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Mint viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Mint'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-sage',
    name: 'Pansy - Sage',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sage pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Sage'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-teal',
    name: 'Johnny jump up - Teal',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Teal johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Teal'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-turquoise',
    name: 'Chive blossom - Turquoise',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Turquoise chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Turquoise'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-aqua',
    name: 'Squash blossom - Aqua',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Aqua squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Aqua'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-cyan',
    name: 'Elderflower - Cyan',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cyan elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Cyan'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-sky',
    name: 'Rose - Sky',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sky rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Sky'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-blue',
    name: 'Nasturtium - Blue',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Blue nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Blue'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-azure',
    name: 'Borage - Azure',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Azure borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Azure'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-cobalt',
    name: 'Calendula - Cobalt',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cobalt calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Cobalt'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-navy',
    name: 'Viola - Navy',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Navy viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Navy'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-sapphire',
    name: 'Pansy - Sapphire',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sapphire pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Sapphire'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-indigo',
    name: 'Johnny jump up - Indigo',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Indigo johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Indigo'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-violet',
    name: 'Chive blossom - Violet',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Violet chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Violet'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-purple',
    name: 'Squash blossom - Purple',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Purple squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Purple'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-lavender',
    name: 'Elderflower - Lavender',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Lavender elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Lavender'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-lilac',
    name: 'Rose - Lilac',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Lilac rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Lilac'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-magenta',
    name: 'Nasturtium - Magenta',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Magenta nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Magenta'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-fuchsia',
    name: 'Borage - Fuchsia',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Fuchsia borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Fuchsia'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-hot-pink',
    name: 'Calendula - Hot Pink',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Hot Pink calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Hot Pink'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-rose',
    name: 'Viola - Rose',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Rose viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Rose'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-bubblegum',
    name: 'Pansy - Bubblegum',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Bubblegum pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Bubblegum'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-pink',
    name: 'Johnny jump up - Pink',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Pink johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Pink'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-blush',
    name: 'Chive blossom - Blush',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Blush chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Blush'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-shell',
    name: 'Squash blossom - Shell',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Shell squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Shell'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-petal',
    name: 'Elderflower - Petal',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Petal elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Petal'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-blossom',
    name: 'Rose - Blossom',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Blossom rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Blossom'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-crimson',
    name: 'Nasturtium - Crimson',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Crimson nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Crimson'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-burgundy',
    name: 'Borage - Burgundy',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Burgundy borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Burgundy'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-wine',
    name: 'Calendula - Wine',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Wine calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Wine'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-merlot',
    name: 'Viola - Merlot',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Merlot viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Merlot'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-ruby',
    name: 'Pansy - Ruby',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ruby pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Ruby'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-jewel-mix-2',
    name: 'Johnny jump up - Jewel Mix 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Jewel Mix 2 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Jewel Mix 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-alaska-2',
    name: 'Chive blossom - Alaska 2',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Alaska 2 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Alaska 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-empress-2',
    name: 'Squash blossom - Empress 2',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Empress 2 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Empress 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-moonlight-2',
    name: 'Elderflower - Moonlight 2',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Moonlight 2 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Moonlight 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-whirlybird-2',
    name: 'Rose - Whirlybird 2',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Whirlybird 2 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Whirlybird 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-peach-melba-2',
    name: 'Nasturtium - Peach Melba 2',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Peach Melba 2 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Peach Melba 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-canary-creeper-2',
    name: 'Borage - Canary Creeper 2',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Canary Creeper 2 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Canary Creeper 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-spitfire-2',
    name: 'Calendula - Spitfire 2',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Spitfire 2 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Spitfire 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-troika-2',
    name: 'Viola - Troika 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Troika 2 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Troika 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-golden-2',
    name: 'Pansy - Golden 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Golden 2 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Golden 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-blue-2',
    name: 'Johnny jump up - Blue 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Blue 2 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Blue 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-white-2',
    name: 'Chive blossom - White 2',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'White 2 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['White 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-purple-2',
    name: 'Squash blossom - Purple 2',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Purple 2 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Purple 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-pink-2',
    name: 'Elderflower - Pink 2',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Pink 2 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Pink 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-lavender-2',
    name: 'Rose - Lavender 2',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Lavender 2 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Lavender 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-pacific-beauty-2',
    name: 'Nasturtium - Pacific Beauty 2',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Pacific Beauty 2 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Pacific Beauty 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-resina-2',
    name: 'Borage - Resina 2',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Resina 2 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Resina 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-radio-2',
    name: 'Calendula - Radio 2',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Radio 2 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Radio 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-bronze-2',
    name: 'Viola - Bronze 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Bronze 2 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Bronze 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-pink-surprise-2',
    name: 'Pansy - Pink Surprise 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Pink Surprise 2 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Pink Surprise 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-sorbet-2',
    name: 'Johnny jump up - Sorbet 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sorbet 2 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Sorbet 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-penny-2',
    name: 'Chive blossom - Penny 2',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Penny 2 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Penny 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-majestic-giants-2',
    name: 'Squash blossom - Majestic Giants 2',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Majestic Giants 2 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Majestic Giants 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-colossus-2',
    name: 'Elderflower - Colossus 2',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Colossus 2 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Colossus 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-delta-2',
    name: 'Rose - Delta 2',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Delta 2 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Delta 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-johnny-jump-up-2',
    name: 'Nasturtium - Johnny Jump Up 2',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Johnny Jump Up 2 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Johnny Jump Up 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-helen-mount-2',
    name: 'Borage - Helen Mount 2',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Helen Mount 2 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Helen Mount 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-wild-pansy-2',
    name: 'Calendula - Wild Pansy 2',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Wild Pansy 2 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Wild Pansy 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-heartsease-2',
    name: 'Viola - Heartsease 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Heartsease 2 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Heartsease 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-field-2',
    name: 'Pansy - Field 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Field 2 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Field 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-garlic-2',
    name: 'Johnny jump up - Garlic 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Garlic 2 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Garlic 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-onion-2',
    name: 'Chive blossom - Onion 2',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Onion 2 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Onion 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-chinese-2',
    name: 'Squash blossom - Chinese 2',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Chinese 2 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Chinese 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-siberian-2',
    name: 'Elderflower - Siberian 2',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Siberian 2 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Siberian 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-giant-2',
    name: 'Rose - Giant 2',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Giant 2 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Giant 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-zucchini-2',
    name: 'Nasturtium - Zucchini 2',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Zucchini 2 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Zucchini 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-pumpkin-2',
    name: 'Borage - Pumpkin 2',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Pumpkin 2 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Pumpkin 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-squash-2',
    name: 'Calendula - Squash 2',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Squash 2 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Squash 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-summer-2',
    name: 'Viola - Summer 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Summer 2 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Summer 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-winter-2',
    name: 'Pansy - Winter 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Winter 2 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Winter 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-black-lace-2',
    name: 'Johnny jump up - Black Lace 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Black Lace 2 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Black Lace 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-sambucus-2',
    name: 'Chive blossom - Sambucus 2',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sambucus 2 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sambucus 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-american-2',
    name: 'Squash blossom - American 2',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'American 2 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['American 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-european-2',
    name: 'Elderflower - European 2',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'European 2 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['European 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-blue-2',
    name: 'Rose - Blue 2',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Blue 2 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Blue 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-damask-2',
    name: 'Nasturtium - Damask 2',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Damask 2 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Damask 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-tea-2',
    name: 'Borage - Tea 2',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Tea 2 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Tea 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-floribunda-2',
    name: 'Calendula - Floribunda 2',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Floribunda 2 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Floribunda 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-grandiflora-2',
    name: 'Viola - Grandiflora 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Grandiflora 2 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Grandiflora 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-climbing-2',
    name: 'Pansy - Climbing 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Climbing 2 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Climbing 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-heritage-2',
    name: 'Johnny jump up - Heritage 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Heritage 2 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Heritage 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-old-garden-2',
    name: 'Chive blossom - Old Garden 2',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Old Garden 2 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Old Garden 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-species-2',
    name: 'Squash blossom - Species 2',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Species 2 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Species 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-miniature-2',
    name: 'Elderflower - Miniature 2',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Miniature 2 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Miniature 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-ground-cover-2',
    name: 'Rose - Ground Cover 2',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ground Cover 2 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Ground Cover 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-red-2',
    name: 'Nasturtium - Red 2',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Red 2 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Red 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-orange-2',
    name: 'Borage - Orange 2',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Orange 2 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Orange 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-yellow-2',
    name: 'Calendula - Yellow 2',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Yellow 2 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Yellow 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-cream-2',
    name: 'Viola - Cream 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cream 2 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Cream 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-apricot-2',
    name: 'Pansy - Apricot 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Apricot 2 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Apricot 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-coral-2',
    name: 'Johnny jump up - Coral 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Coral 2 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Coral 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-salmon-2',
    name: 'Chive blossom - Salmon 2',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Salmon 2 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Salmon 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-peach-2',
    name: 'Squash blossom - Peach 2',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Peach 2 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Peach 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-mango-2',
    name: 'Elderflower - Mango 2',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Mango 2 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Mango 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-tangerine-2',
    name: 'Rose - Tangerine 2',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Tangerine 2 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Tangerine 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-gold-2',
    name: 'Nasturtium - Gold 2',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Gold 2 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Gold 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-lemon-2',
    name: 'Borage - Lemon 2',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Lemon 2 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Lemon 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-butter-2',
    name: 'Calendula - Butter 2',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Butter 2 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Butter 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-canary-2',
    name: 'Viola - Canary 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Canary 2 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Canary 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-maize-2',
    name: 'Pansy - Maize 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Maize 2 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Maize 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-chartreuse-2',
    name: 'Johnny jump up - Chartreuse 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Chartreuse 2 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Chartreuse 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-lime-2',
    name: 'Chive blossom - Lime 2',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Lime 2 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Lime 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-green-2',
    name: 'Squash blossom - Green 2',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Green 2 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Green 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-mint-2',
    name: 'Elderflower - Mint 2',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Mint 2 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Mint 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-sage-2',
    name: 'Rose - Sage 2',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sage 2 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Sage 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-teal-2',
    name: 'Nasturtium - Teal 2',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Teal 2 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Teal 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-turquoise-2',
    name: 'Borage - Turquoise 2',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Turquoise 2 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Turquoise 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-aqua-2',
    name: 'Calendula - Aqua 2',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Aqua 2 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Aqua 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-cyan-2',
    name: 'Viola - Cyan 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cyan 2 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Cyan 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-sky-2',
    name: 'Pansy - Sky 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sky 2 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Sky 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-blue-2',
    name: 'Johnny jump up - Blue 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Blue 2 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Blue 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-azure-2',
    name: 'Chive blossom - Azure 2',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Azure 2 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Azure 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-cobalt-2',
    name: 'Squash blossom - Cobalt 2',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cobalt 2 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Cobalt 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-navy-2',
    name: 'Elderflower - Navy 2',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Navy 2 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Navy 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-sapphire-2',
    name: 'Rose - Sapphire 2',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sapphire 2 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Sapphire 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-indigo-2',
    name: 'Nasturtium - Indigo 2',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Indigo 2 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Indigo 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-violet-2',
    name: 'Borage - Violet 2',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Violet 2 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Violet 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-purple-2',
    name: 'Calendula - Purple 2',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Purple 2 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Purple 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-lavender-2',
    name: 'Viola - Lavender 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Lavender 2 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Lavender 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-lilac-2',
    name: 'Pansy - Lilac 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Lilac 2 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Lilac 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-magenta-2',
    name: 'Johnny jump up - Magenta 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Magenta 2 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Magenta 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-fuchsia-2',
    name: 'Chive blossom - Fuchsia 2',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Fuchsia 2 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Fuchsia 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-hot-pink-2',
    name: 'Squash blossom - Hot Pink 2',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Hot Pink 2 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Hot Pink 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-rose-2',
    name: 'Elderflower - Rose 2',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Rose 2 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Rose 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-bubblegum-2',
    name: 'Rose - Bubblegum 2',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Bubblegum 2 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Bubblegum 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-pink-2',
    name: 'Nasturtium - Pink 2',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Pink 2 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Pink 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-blush-2',
    name: 'Borage - Blush 2',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Blush 2 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Blush 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-shell-2',
    name: 'Calendula - Shell 2',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Shell 2 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Shell 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-petal-2',
    name: 'Viola - Petal 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Petal 2 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Petal 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-blossom-2',
    name: 'Pansy - Blossom 2',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Blossom 2 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Blossom 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-crimson-2',
    name: 'Johnny jump up - Crimson 2',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Crimson 2 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Crimson 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-burgundy-2',
    name: 'Chive blossom - Burgundy 2',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Burgundy 2 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Burgundy 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-wine-2',
    name: 'Squash blossom - Wine 2',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Wine 2 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Wine 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-merlot-2',
    name: 'Elderflower - Merlot 2',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Merlot 2 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Merlot 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-ruby-2',
    name: 'Rose - Ruby 2',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ruby 2 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Ruby 2'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-jewel-mix-3',
    name: 'Nasturtium - Jewel Mix 3',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Jewel Mix 3 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Jewel Mix 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-alaska-3',
    name: 'Borage - Alaska 3',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Alaska 3 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Alaska 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-empress-3',
    name: 'Calendula - Empress 3',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Empress 3 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Empress 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-moonlight-3',
    name: 'Viola - Moonlight 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Moonlight 3 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Moonlight 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-whirlybird-3',
    name: 'Pansy - Whirlybird 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Whirlybird 3 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Whirlybird 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-peach-melba-3',
    name: 'Johnny jump up - Peach Melba 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Peach Melba 3 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Peach Melba 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-canary-creeper-3',
    name: 'Chive blossom - Canary Creeper 3',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Canary Creeper 3 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Canary Creeper 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-spitfire-3',
    name: 'Squash blossom - Spitfire 3',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Spitfire 3 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Spitfire 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-troika-3',
    name: 'Elderflower - Troika 3',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Troika 3 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Troika 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-golden-3',
    name: 'Rose - Golden 3',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Golden 3 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Golden 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-blue-3',
    name: 'Nasturtium - Blue 3',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Blue 3 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Blue 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-white-3',
    name: 'Borage - White 3',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'White 3 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['White 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-purple-3',
    name: 'Calendula - Purple 3',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Purple 3 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Purple 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-pink-3',
    name: 'Viola - Pink 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Pink 3 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Pink 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-lavender-3',
    name: 'Pansy - Lavender 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Lavender 3 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Lavender 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-pacific-beauty-3',
    name: 'Johnny jump up - Pacific Beauty 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Pacific Beauty 3 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Pacific Beauty 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-resina-3',
    name: 'Chive blossom - Resina 3',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Resina 3 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Resina 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-radio-3',
    name: 'Squash blossom - Radio 3',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Radio 3 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Radio 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-bronze-3',
    name: 'Elderflower - Bronze 3',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Bronze 3 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Bronze 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-pink-surprise-3',
    name: 'Rose - Pink Surprise 3',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Pink Surprise 3 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Pink Surprise 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-sorbet-3',
    name: 'Nasturtium - Sorbet 3',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Sorbet 3 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Sorbet 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-penny-3',
    name: 'Borage - Penny 3',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Penny 3 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Penny 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-majestic-giants-3',
    name: 'Calendula - Majestic Giants 3',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Majestic Giants 3 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Majestic Giants 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-colossus-3',
    name: 'Viola - Colossus 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Colossus 3 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Colossus 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-delta-3',
    name: 'Pansy - Delta 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Delta 3 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Delta 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-johnny-jump-up-3',
    name: 'Johnny jump up - Johnny Jump Up 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Johnny Jump Up 3 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Johnny Jump Up 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-helen-mount-3',
    name: 'Chive blossom - Helen Mount 3',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Helen Mount 3 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Helen Mount 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-wild-pansy-3',
    name: 'Squash blossom - Wild Pansy 3',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Wild Pansy 3 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Wild Pansy 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-heartsease-3',
    name: 'Elderflower - Heartsease 3',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Heartsease 3 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Heartsease 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-field-3',
    name: 'Rose - Field 3',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Field 3 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Field 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-garlic-3',
    name: 'Nasturtium - Garlic 3',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Garlic 3 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Garlic 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-onion-3',
    name: 'Borage - Onion 3',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Onion 3 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Onion 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-chinese-3',
    name: 'Calendula - Chinese 3',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Chinese 3 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Chinese 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-siberian-3',
    name: 'Viola - Siberian 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Siberian 3 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Siberian 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-giant-3',
    name: 'Pansy - Giant 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Giant 3 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Giant 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-zucchini-3',
    name: 'Johnny jump up - Zucchini 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Zucchini 3 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Zucchini 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-pumpkin-3',
    name: 'Chive blossom - Pumpkin 3',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Pumpkin 3 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Pumpkin 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-squash-3',
    name: 'Squash blossom - Squash 3',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Squash 3 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Squash 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-summer-3',
    name: 'Elderflower - Summer 3',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Summer 3 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Summer 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-winter-3',
    name: 'Rose - Winter 3',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Winter 3 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Winter 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-black-lace-3',
    name: 'Nasturtium - Black Lace 3',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Black Lace 3 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Black Lace 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-sambucus-3',
    name: 'Borage - Sambucus 3',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Sambucus 3 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Sambucus 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-american-3',
    name: 'Calendula - American 3',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'American 3 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['American 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-european-3',
    name: 'Viola - European 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'European 3 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['European 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-blue-3',
    name: 'Pansy - Blue 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Blue 3 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Blue 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-damask-3',
    name: 'Johnny jump up - Damask 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Damask 3 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Damask 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-tea-3',
    name: 'Chive blossom - Tea 3',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Tea 3 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Tea 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-floribunda-3',
    name: 'Squash blossom - Floribunda 3',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Floribunda 3 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Floribunda 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-grandiflora-3',
    name: 'Elderflower - Grandiflora 3',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Grandiflora 3 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Grandiflora 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-climbing-3',
    name: 'Rose - Climbing 3',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Climbing 3 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Climbing 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-heritage-3',
    name: 'Nasturtium - Heritage 3',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Heritage 3 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Heritage 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-old-garden-3',
    name: 'Borage - Old Garden 3',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Old Garden 3 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Old Garden 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-species-3',
    name: 'Calendula - Species 3',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Species 3 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Species 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-miniature-3',
    name: 'Viola - Miniature 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Miniature 3 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Miniature 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-ground-cover-3',
    name: 'Pansy - Ground Cover 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ground Cover 3 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Ground Cover 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-red-3',
    name: 'Johnny jump up - Red 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Red 3 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Red 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-orange-3',
    name: 'Chive blossom - Orange 3',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Orange 3 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Orange 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-yellow-3',
    name: 'Squash blossom - Yellow 3',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Yellow 3 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Yellow 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-cream-3',
    name: 'Elderflower - Cream 3',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cream 3 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Cream 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-apricot-3',
    name: 'Rose - Apricot 3',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Apricot 3 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Apricot 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-coral-3',
    name: 'Nasturtium - Coral 3',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Coral 3 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Coral 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-salmon-3',
    name: 'Borage - Salmon 3',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Salmon 3 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Salmon 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-peach-3',
    name: 'Calendula - Peach 3',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Peach 3 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Peach 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-mango-3',
    name: 'Viola - Mango 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Mango 3 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Mango 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-tangerine-3',
    name: 'Pansy - Tangerine 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Tangerine 3 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Tangerine 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-gold-3',
    name: 'Johnny jump up - Gold 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Gold 3 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Gold 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-lemon-3',
    name: 'Chive blossom - Lemon 3',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Lemon 3 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Lemon 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-butter-3',
    name: 'Squash blossom - Butter 3',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Butter 3 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Butter 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-canary-3',
    name: 'Elderflower - Canary 3',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Canary 3 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Canary 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-maize-3',
    name: 'Rose - Maize 3',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Maize 3 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Maize 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-chartreuse-3',
    name: 'Nasturtium - Chartreuse 3',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Chartreuse 3 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Chartreuse 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-lime-3',
    name: 'Borage - Lime 3',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Lime 3 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Lime 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-green-3',
    name: 'Calendula - Green 3',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Green 3 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Green 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-mint-3',
    name: 'Viola - Mint 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Mint 3 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Mint 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-sage-3',
    name: 'Pansy - Sage 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sage 3 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Sage 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-teal-3',
    name: 'Johnny jump up - Teal 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Teal 3 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Teal 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-turquoise-3',
    name: 'Chive blossom - Turquoise 3',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Turquoise 3 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Turquoise 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-aqua-3',
    name: 'Squash blossom - Aqua 3',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Aqua 3 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Aqua 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-cyan-3',
    name: 'Elderflower - Cyan 3',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cyan 3 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Cyan 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-sky-3',
    name: 'Rose - Sky 3',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sky 3 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Sky 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-blue-3',
    name: 'Nasturtium - Blue 3',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Blue 3 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Blue 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-azure-3',
    name: 'Borage - Azure 3',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Azure 3 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Azure 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-cobalt-3',
    name: 'Calendula - Cobalt 3',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cobalt 3 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Cobalt 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-navy-3',
    name: 'Viola - Navy 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Navy 3 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Navy 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-sapphire-3',
    name: 'Pansy - Sapphire 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sapphire 3 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Sapphire 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-indigo-3',
    name: 'Johnny jump up - Indigo 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Indigo 3 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Indigo 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-violet-3',
    name: 'Chive blossom - Violet 3',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Violet 3 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Violet 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-purple-3',
    name: 'Squash blossom - Purple 3',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Purple 3 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Purple 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-lavender-3',
    name: 'Elderflower - Lavender 3',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Lavender 3 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Lavender 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-lilac-3',
    name: 'Rose - Lilac 3',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Lilac 3 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Lilac 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-magenta-3',
    name: 'Nasturtium - Magenta 3',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Magenta 3 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Magenta 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-fuchsia-3',
    name: 'Borage - Fuchsia 3',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Fuchsia 3 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Fuchsia 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-hot-pink-3',
    name: 'Calendula - Hot Pink 3',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Hot Pink 3 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Hot Pink 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-rose-3',
    name: 'Viola - Rose 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Rose 3 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Rose 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-bubblegum-3',
    name: 'Pansy - Bubblegum 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Bubblegum 3 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Bubblegum 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-pink-3',
    name: 'Johnny jump up - Pink 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Pink 3 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Pink 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-blush-3',
    name: 'Chive blossom - Blush 3',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Blush 3 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Blush 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-shell-3',
    name: 'Squash blossom - Shell 3',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Shell 3 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Shell 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-petal-3',
    name: 'Elderflower - Petal 3',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Petal 3 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Petal 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-blossom-3',
    name: 'Rose - Blossom 3',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Blossom 3 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Blossom 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-crimson-3',
    name: 'Nasturtium - Crimson 3',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Crimson 3 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Crimson 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-burgundy-3',
    name: 'Borage - Burgundy 3',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Burgundy 3 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Burgundy 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-wine-3',
    name: 'Calendula - Wine 3',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Wine 3 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Wine 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-merlot-3',
    name: 'Viola - Merlot 3',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Merlot 3 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Merlot 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-ruby-3',
    name: 'Pansy - Ruby 3',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ruby 3 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Ruby 3'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-jewel-mix-4',
    name: 'Johnny jump up - Jewel Mix 4',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Jewel Mix 4 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Jewel Mix 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-alaska-4',
    name: 'Chive blossom - Alaska 4',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Alaska 4 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Alaska 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-empress-4',
    name: 'Squash blossom - Empress 4',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Empress 4 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Empress 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-moonlight-4',
    name: 'Elderflower - Moonlight 4',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Moonlight 4 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Moonlight 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-whirlybird-4',
    name: 'Rose - Whirlybird 4',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Whirlybird 4 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Whirlybird 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-peach-melba-4',
    name: 'Nasturtium - Peach Melba 4',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Peach Melba 4 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Peach Melba 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-canary-creeper-4',
    name: 'Borage - Canary Creeper 4',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Canary Creeper 4 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Canary Creeper 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-spitfire-4',
    name: 'Calendula - Spitfire 4',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Spitfire 4 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Spitfire 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-troika-4',
    name: 'Viola - Troika 4',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Troika 4 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Troika 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-golden-4',
    name: 'Pansy - Golden 4',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Golden 4 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Golden 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-blue-4',
    name: 'Johnny jump up - Blue 4',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Blue 4 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Blue 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-white-4',
    name: 'Chive blossom - White 4',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'White 4 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['White 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-purple-4',
    name: 'Squash blossom - Purple 4',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Purple 4 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Purple 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-pink-4',
    name: 'Elderflower - Pink 4',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Pink 4 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Pink 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-lavender-4',
    name: 'Rose - Lavender 4',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Lavender 4 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Lavender 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-pacific-beauty-4',
    name: 'Nasturtium - Pacific Beauty 4',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Pacific Beauty 4 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Pacific Beauty 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-resina-4',
    name: 'Borage - Resina 4',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Resina 4 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Resina 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-radio-4',
    name: 'Calendula - Radio 4',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Radio 4 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Radio 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-bronze-4',
    name: 'Viola - Bronze 4',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Bronze 4 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Bronze 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-pink-surprise-4',
    name: 'Pansy - Pink Surprise 4',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Pink Surprise 4 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Pink Surprise 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-sorbet-4',
    name: 'Johnny jump up - Sorbet 4',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sorbet 4 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Sorbet 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-penny-4',
    name: 'Chive blossom - Penny 4',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Penny 4 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Penny 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-majestic-giants-4',
    name: 'Squash blossom - Majestic Giants 4',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Majestic Giants 4 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Majestic Giants 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-colossus-4',
    name: 'Elderflower - Colossus 4',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Colossus 4 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Colossus 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-delta-4',
    name: 'Rose - Delta 4',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Delta 4 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Delta 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-johnny-jump-up-4',
    name: 'Nasturtium - Johnny Jump Up 4',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Johnny Jump Up 4 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Johnny Jump Up 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-helen-mount-4',
    name: 'Borage - Helen Mount 4',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Helen Mount 4 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Helen Mount 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-wild-pansy-4',
    name: 'Calendula - Wild Pansy 4',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Wild Pansy 4 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Wild Pansy 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-heartsease-4',
    name: 'Viola - Heartsease 4',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Heartsease 4 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Heartsease 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-field-4',
    name: 'Pansy - Field 4',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Field 4 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Field 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-garlic-4',
    name: 'Johnny jump up - Garlic 4',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Garlic 4 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Garlic 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-onion-4',
    name: 'Chive blossom - Onion 4',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Onion 4 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Onion 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-chinese-4',
    name: 'Squash blossom - Chinese 4',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Chinese 4 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Chinese 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-siberian-4',
    name: 'Elderflower - Siberian 4',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Siberian 4 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Siberian 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-giant-4',
    name: 'Rose - Giant 4',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Giant 4 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Giant 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-zucchini-4',
    name: 'Nasturtium - Zucchini 4',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Zucchini 4 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Zucchini 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-pumpkin-4',
    name: 'Borage - Pumpkin 4',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Pumpkin 4 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Pumpkin 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-squash-4',
    name: 'Calendula - Squash 4',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Squash 4 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Squash 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-summer-4',
    name: 'Viola - Summer 4',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Summer 4 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Summer 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-winter-4',
    name: 'Pansy - Winter 4',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Winter 4 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Winter 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-black-lace-4',
    name: 'Johnny jump up - Black Lace 4',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Black Lace 4 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Black Lace 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-sambucus-4',
    name: 'Chive blossom - Sambucus 4',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sambucus 4 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sambucus 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-american-4',
    name: 'Squash blossom - American 4',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'American 4 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['American 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-european-4',
    name: 'Elderflower - European 4',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'European 4 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['European 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-blue-4',
    name: 'Rose - Blue 4',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Blue 4 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Blue 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-damask-4',
    name: 'Nasturtium - Damask 4',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Damask 4 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Damask 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-tea-4',
    name: 'Borage - Tea 4',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Tea 4 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Tea 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-floribunda-4',
    name: 'Calendula - Floribunda 4',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Floribunda 4 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Floribunda 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-grandiflora-4',
    name: 'Viola - Grandiflora 4',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Grandiflora 4 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Grandiflora 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-climbing-4',
    name: 'Pansy - Climbing 4',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Climbing 4 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Climbing 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-heritage-4',
    name: 'Johnny jump up - Heritage 4',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Heritage 4 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Heritage 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-old-garden-4',
    name: 'Chive blossom - Old Garden 4',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Old Garden 4 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Old Garden 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-species-4',
    name: 'Squash blossom - Species 4',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Species 4 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Species 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-miniature-4',
    name: 'Elderflower - Miniature 4',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Miniature 4 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Miniature 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-ground-cover-4',
    name: 'Rose - Ground Cover 4',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Ground Cover 4 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Ground Cover 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-red-4',
    name: 'Nasturtium - Red 4',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Red 4 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Red 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-orange-4',
    name: 'Borage - Orange 4',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Orange 4 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Orange 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-yellow-4',
    name: 'Calendula - Yellow 4',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Yellow 4 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Yellow 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-cream-4',
    name: 'Viola - Cream 4',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cream 4 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Cream 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-apricot-4',
    name: 'Pansy - Apricot 4',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Apricot 4 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Apricot 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-coral-4',
    name: 'Johnny jump up - Coral 4',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Coral 4 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Coral 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-salmon-4',
    name: 'Chive blossom - Salmon 4',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Salmon 4 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Salmon 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-peach-4',
    name: 'Squash blossom - Peach 4',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Peach 4 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Peach 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-mango-4',
    name: 'Elderflower - Mango 4',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Mango 4 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Mango 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  }
]
